<template>
<MDBBtn ref="btnOpenModalDesign" color="primary" aria-controls="openModelToDesign" class="btn-addProductIdToUserDesigns" @click="addProductIdToUserDesigns()">
    open design screen
</MDBBtn>
<MDBBtn color="primary" @click="store.resetCurrentEditingProps()">
    Reset Current Editing Props
</MDBBtn>
<input id="input-add-status" hidden/>

<div class="div-insertDesignsToVariantProduct" style="display: none" data-design-to-add="">
    <button type="button" class="btn-insertDesignsToVariantProduct" @click="insertDesignsToVariantProduct()"></button>
</div>
<div style="display: none">
    insert Designs To Variant Product Change Design
    <button type="button" id="btn-insertDesignsToVariantProductChangeDesign" @click="insertDesignsToVariantProductChangeDesign()"></button>
</div>

<div id="div-designImageData" data-design-img=""></div>
<div id="div-totalPrice" data-total-price=""></div>
<div id="div-designsExplains" data-designs-explains=""></div>

<span v-if="!show">Loading...</span>
<!-- להפוך את הדף הזה להיות על פופאפ כמו בדף הרגיל -->
<MDBModal id="openModelToDesign" tabindex="-1" labelledby="openModelToDesignTitle" v-model="openModelToDesign" centered>
    <MDBModalBody ref="modalBodyRef" v-if="show">
        <div class="modal-body-container">
            <div class="body-top" v-if="noUsefulImages == true">
                <span style="font-size: 26px;
                            align-content: center;
                            width: 100%;
                            text-align: center;
                            color: red;
                            font-weight: bold;">
                    No editable images found for this product.
                </span>
            </div>
            <div class="body-top" v-else>
                <div class="left" v-if="this.store.currentEditingProps.imageToPreview" style="background-color: #f8f8f8" @click="exitScroll()">
                    <div class="left-top">
                        <span class="title" @click="store.mergeMultipleSVGs(uStore.userDesigns[store.currentEditingProps.productId]
                    .designs[store.currentEditingProps.variantId].imgVariants[
                    store.currentEditingProps.imageToPreview
                  ].texts, uStore.userDesigns[store.currentEditingProps.productId]
                    .designs[store.currentEditingProps.variantId].imgVariants[
                    store.currentEditingProps.imageToPreview
                  ].arts)">PREVIEW</span>
                        <span class="prev-container">
                            <!-- <span class="prev-circle"></span> -->
                            <div class="toggle-container">
                                <span class="toggle-label">Preview</span>
                                <label class="toggle">
                                    <input type="checkbox" />
                                    <span class="slider" @click="toggleBoundaries"></span>
                                </label>
                            </div>
                            <!-- <span class="prev-txt">Preview</span>
                                <div class="toggle-switch">
                                    <button id="Perview" :class="{ active: showBoundaries }"
                                        @click="showBoundaries = true"></button>
                                    <button id="!Perview" :class="{ active: !showBoundaries }"
                                        @click="showBoundaries = false"></button>
                                </div> -->
                        </span>
                    </div>
                    <div class="left-middle">
                        <div class="middle-left"> 
                            <div v-for="(
                    image, index
                 
                  ) in store.getAllProductVariantUsefulImagesWithoutImg(
                    store.currentEditingProps.productId,
                    store.currentEditingProps.variantId,
                    store.currentEditingProps.imageToPreview
                  )" style="display: grid" :key="index" class="images-container" @click.stop="changeImg(image)">
                                <div class="bg-image hover-zoom">
                                    <img ref="embCanvas" style="padding: 5px; max-width: 100%; max-height: 100%" :title="image.imageName" :src="image.file.relativePath.replaceAll('\\', '\\\\')" hover-overlay hover-zoom hover-shadow />
                                </div>
                                <!-- <span style="font-size: 10px;">{{ image.imageName }}</span> -->
                            </div>
                        </div>
                        <!-- {{ store.getCurrentProduct() }} -->
                        <div class="middle-center" :key="store.movInd" v-if="
                  uStore.userDesigns[store.currentEditingProps.productId]
                    .designs[store.currentEditingProps.variantId].imgVariants[
                    store.currentEditingProps.imageToPreview
                  ] != undefined
                ">
                            <!-- {{ translateX.toFixed(1) }} # {{translateY.toFixed(1)}} # {{ scale }} 
              #dpi#{{ store.currentEditingProps.dpi }} #topLeftDmmY {{ store.getCurrentProduct().box.topLeftDmm.y }} #dmmX {{ store.getCurrentProduct().box.topLeftDmm.x }} -->
                            <!-- <button @click="resetScale()">reset scale</button>
                    {{ store.currentEditingProps.dpi }} -->
                            <div class="middle-center-top" ref="productBoxContainer">
                                <div class="product-box" ref="imgBoxContainer">
                                    <!-- :style="`transform: translate(${translateX}px, ${translateY}px) scale(${scale})`" -->
                                    <div ref="embCanvasCurrent" :class="{ 'preview-box': !showBoundaries }" class="emb-canvas" :style="
                        `background-image: ${store.currentEditingProps.currentImgPath};
                         transform: translate(${translateX}px, ${translateY}px) scale(${scale});
                         transform-origin: 0 0`
                      ">
                                        <!-- transform: translate(${translateX}px, ${translateY}px) scale(${scale}) -->
                                        <div ref="currentBoxRef" class="overlay-bd" :style="{
                        height:
                          store.getCurrentProduct().box.heightInches *
                            store.currentEditingProps.dpi +
                          'px',
                        width:
                          store.getCurrentProduct().box.widthInches *
                            store.currentEditingProps.dpi +
                          'px',
                          transform: 'translate(' + store.getCurrentProduct().box.topLeftDmm.x *
                            (store.currentEditingProps.dpi / 254.0) +
                          'px,' + store.getCurrentProduct().box.topLeftDmm.y *
                            (store.currentEditingProps.dpi / 254.0) +
                          'px)',
                        border: showBoundaries == false
                            ? '2px dashed transparent'
                            : '2px dashed yellow',
                        position: 'absolute',
                        display: 'block',
                        boxSizing: 'border-box',
                      }">
                                            <!-- <template v-for="(artObjectToShow, index) in getAllArtsFromDesign()" :key="index"> -->
                                            <template v-for="(artObjectToShow, index) in uStore.userDesigns[
                          this.store.currentEditingProps.productId
                        ].designs[this.store.currentEditingProps.variantId]
                          .imgVariants[
                          this.store.currentEditingProps.imageToPreview
                        ].arts" :key="index">
                                                <div ref="artsElementsRefs" :id="`target_art_${index}`" @click.stop="selectElementToPreview('art', index)" class="ele-container">
                                                    <DSTPreview v-if="store.currentEditingProps.isDesignDst == true" :dwidth="
                              (store.allArts.value[artObjectToShow.artID].sizes[
                                artObjectToShow.artSizeID
                              ].dstfile.pixelWidth *
                                store.currentEditingProps.dpi) /
                              254.0
                            " :dheight="
                              (store.allArts.value[artObjectToShow.artID].sizes[
                                artObjectToShow.artSizeID
                              ].dstfile.pixelHeight *
                                store.currentEditingProps.dpi) /
                              254.0
                            " :dstFile="
                              this.store.allArts.value[artObjectToShow.artID]
                                .sizes[artObjectToShow.artSizeID].dstfile
                            " :layersColors="artObjectToShow.colors" :arc="parseFloat(artObjectToShow.artArc)">
                                                    </DSTPreview>
                                                    <div v-else>
                                                        <!-- <div :style="{backgroundImage: `url('${store.baseURL}/${store.allArtsSVG.value[artObjectToShow.artID].svgFile.relativePath.replaceAll('\\', '\\\\')}')`,
                                                display: 'block', width: '100%', height: '100%',
                                                filter: `url(#ColorFilter-${artObjectToShow.colors[0]})`
                                                }"></div> -->

                                                        <!-- <svg width="200" height="200">
                                                    <image href="C:\Users\PC\Downloads\2024.svg" width="200" height="200" filter="url(#ColorFilter-32)" />
                                                </svg> -->
                                                        <svg style="width: 100%; height: 100%">
                                                            <image :href="`${
                                  store.baseURL
                                }/${store.allArtsSVG.value[
                                  artObjectToShow.artID
                                ].svgFile.relativePath.replaceAll(
                                  '\\',
                                  '\\\\'
                                )}`" :filter="`url(#ColorFilterSVG-${artObjectToShow.colors[0]})`" />
                                                        </svg>

                                                        <!-- <img :src="store.baseURL + '/' + store.allArtsSVG.value[artObjectToShow.artID].svgFile.relativePath"> -->
                                                    </div>
                                                </div>

                                                <Moveable :target="`#target_art_${index}`" :style="`display: ${
                                                
                            showBoundaries &&
                            store.currentEditingProps.currentPreview == 'art' &&
                            store.currentEditingProps.currentPreviewIndex ==
                              index
                              ? 'block'
                              : 'none'
                          }`" :draggable="true" :scalable="true" :rotatable="true" :keepRatio="true" :bounds="bounds" :snappable="true" :zoom="scale" :root-container="moveableRootContainer" :use-accurate-position="true" @drag="onDrag($event, 'art', index)" @scale="onScale($event, 'art', index)" @scaleEnd="onScaleEnd($event, 'art', index)" @rotate="onRotate($event, 'art', index)" />
                                            </template>
                                             <template v-for="(
                          userArtObjectToShow, index
                        ) in store.getAllUserDesignArtsNotEmpty()" :key="index">
                                                <div ref="userArtsElementsRefs" :id="`target_user_art_${index}`" @click.stop="selectElementToPreview('userArt', index)" class="ele-container">
                                                <!-- {{ store.allUserArts.value }} -->
                                                <!-- {{  userArtObjectToShow.userUploadedArtID }} -->
                                                    
                                                <img v-if="store.currentEditingProps.isDesignDst == true && userArtObjectToShow.userUploadedArtID != undefined" :width="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelWidth
                                )}px`" :height="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelHeight
                                )}px`" :src="`${store.baseURL}/${store.allUserArts.value[userArtObjectToShow.userUploadedArtID].relativePath}_original.png`" />

                                                    <svg v-if="store.currentEditingProps.isDesignDst == false && userArtObjectToShow.userUploadedArtID != undefined"
                                                     style="width: 100%; height: 100%">
                                                            <image :href="`${
                                  store.baseURL
                                }/${store.allUserArtsSvg.value[
                                  userArtObjectToShow.userUploadedArtID
                                ].relativePath.replaceAll(
                                  '\\',
                                  '\\\\'
                                )}`" />
                                 <!-- :filter="`url(#ColorFilterSVG-${userArtObjectToShow.colors[0]})`" /> -->
                                                        </svg>
                                                    
                                                    <!-- :width="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelWidth
                                )}px`" :height="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelHeight
                                )}px`" :src="`${store.baseURL}/${store.allUserArts.value[userArtObjectToShow.userUploadedArtID].relativePath}_original.png`" /> -->
                                                </div>
                                                <Moveable :target="`#target_user_art_${index}`" :style="`display: ${
                            showBoundaries &&
                            store.currentEditingProps.currentPreview ==
                              'userArt' &&
                            store.currentEditingProps.currentPreviewIndex ==
                              index
                              ? 'block'
                              : 'none'
                          }`" :draggable="true" :scalable="true" :rotatable="true" :keepRatio="true" :bounds="bounds" :snappable="true" :zoom="scale" :root-container="moveableRootContainer" :use-accurate-position="true" @drag="onDrag($event, 'userArt', index)" @scale="onScale($event, 'userArt', index)" @scaleEnd="onScaleEnd($event, 'userArt', index)" @rotate="onRotate($event, 'userArt', index)" />
                                            </template>


                                            <template v-for="(
                          textObjectToShow, index
                        ) in store.getUserDesignsTextsContentful()" :key="index">
                                                <div ref="textsElementsRefs" :id="`target_text_${index}`" @click.stop="selectElementToPreview('text', index)" class="ele-container" style="display: block;
                                                            width: fit-content;
                                                            height: fit-content;">
                                                    <!-- {{ textObjectToShow.svgContent }} -->
                                                    <TextPreview v-if="store.currentEditingProps.isDesignDst == true" :IDFontToPreview="textObjectToShow.fontID" :IDSizeFontToPreview="textObjectToShow.fontSizeID" :TextToPreview="textObjectToShow.text" :dpi="store.currentEditingProps.dpi" superPos="normal" :layersColors="textObjectToShow.layersColors" :x="0" :y="0" :arc="textObjectToShow.textArc" :inDesign="true">
                                                    </TextPreview>
                                                    <!-- 158585 -->
                                                    <!-- :style="{width: textObjectToShow.dragSize.w +'px', height:textObjectToShow.dragSize.h +'px'}" -->

                                                        <div ref="textRef" v-else style="display: block;
                                                            width: fit-content;
                                                            height: fit-content;" v-html="textObjectToShow.svgContent"></div>

                                                    <!-- <div v-else>
                                                        <svg
                                                            :style="{ width: textObjectToShow.dragSize.w + 'px', height: textObjectToShow.dragSize.h + 'px' }"
                                                            :filter="`url(#ColorFilter-${textObjectToShow.colors[0]})`"
                                                        >
                                                            <foreignObject
                                                            :width="textObjectToShow.dragSize.w"
                                                            :height="textObjectToShow.dragSize.h"
                                                            >
                                                            <div xmlns="http://www.w3.org/1999/xhtml" v-html="textObjectToShow.svgContent"></div>
                                                            </foreignObject>
                                                        </svg>
                                                    </div> -->

                                                    <!-- <div v-else>
                                                        <div>
                                                            <svg style="width: 100%; height: 100%;" :filter="`url(#ColorFilter-${textObjectToShow.colors[0]})`">
                                                            <foreignObject :width="textObjectToShow.dragSize.w" :height="textObjectToShow.dragSize.h">
                                                                <div xmlns="http://www.w3.org/1999/xhtml" v-html="textObjectToShow.svgContent"></div>
                                                            </foreignObject>
                                                            </svg>
                                                        </div>
                                                    </div> -->

                                                    <!-- :scale="textObjectToShow.dragTransform.scale.scaleX" -->
                                                </div>
                                                <Moveable :target="`#target_text_${index}`" :style="`display: ${
                            showBoundaries &&
                            store.currentEditingProps.currentPreview ==
                              'text' &&
                            store.currentEditingProps.currentPreviewIndex ==
                              index
                              ? 'block'
                              : 'none'
                          }`" :draggable="true" :scalable="true" :rotatable="true" :keepRatio="true" :bounds="bounds" :snappable="true"
                          :zoom="scale" :root-container="moveableRootContainer" :use-accurate-position="true"
                          @drag="onDrag($event, 'text', index)" @scale="onScale($event, 'text', index)"
                          @scaleEnd="onScaleEnd($event, 'text', index)" @rotate="onRotate($event, 'text', index)" />
                                            </template>

                                            <template v-for="(monogramObjectToShow, index) in this.uStore
                          .userDesigns[store.currentEditingProps.productId]
                          .designs[store.currentEditingProps.variantId]
                          .imgVariants[store.currentEditingProps.imageToPreview]
                          .monograms" :key="index">
                                                <div ref="monogramsElementsRefs" :id="`target_monogram_${index}`" @click.stop="
                            selectElementToPreview('monogram', index)
                          " class="ele-container">
                        <MonogramPreview :monogramObj="
                              store.allMonograms.value[
                                monogramObjectToShow.monogramID
                              ]
                            " :colorLeftChar="monogramObjectToShow.colorsLeftChar" :colorMiddleChar="
                              monogramObjectToShow.colorsMiddleChar
                            " :colorRightChar="
                              monogramObjectToShow.colorsRightChar
                            " :char1="monogramObjectToShow.leftChar" :char2="monogramObjectToShow.middleChar" :char3="monogramObjectToShow.rightChar" :align="monogramObjectToShow.align" :distance1="monogramObjectToShow.distance1" :distance2="monogramObjectToShow.distance2" :dpi="store.currentEditingProps.dpi">
                                                    </MonogramPreview>
                                                </div>
                                                <Moveable :target="`#target_monogram_${index}`" :style="`display: ${
                            showBoundaries &&
                            store.currentEditingProps.currentPreview ==
                              'monogram' &&
                            store.currentEditingProps.currentPreviewIndex ==
                              index
                              ? 'block'
                              : 'none'
                          }`" :draggable="true" :scalable="true" :rotatable="true" :keepRatio="true" :bounds="bounds" :snappable="true" :zoom="scale" :root-container="moveableRootContainer" :use-accurate-position="true" @drag="onDrag($event, 'monogram', index)" @scale="onScale($event, 'monogram', index)" @scaleEnd="onScaleEnd($event, 'monogram', index)" @rotate="onRotate($event, 'monogram', index)" />
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="this.showCenter" class="middle-center-bottom">
                                    <button class="center-btn" @click.stop="fixHorizontalOrVertical('Horizontal')">
                                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <line x1="7.5" y1="17" x2="7.5" y2="2.24561e-08" stroke="#2D2D2D" />
                                            <line x1="8.74228e-08" y1="7" x2="14" y2="7" stroke="#2D2D2D" stroke-width="2" />
                                            <line x1="3" y1="12" x2="12" y2="12" stroke="#2D2D2D" stroke-width="2" />
                                        </svg>
                                        <span>Horizontal Center</span>
                                    </button>
                                    <button class="center-btn" @click.stop="fixHorizontalOrVertical('Vertical')">
                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <line x1="17" y1="7.03845" x2="4.37114e-08" y2="7.03845" stroke="#2D2D2D" />
                                            <line x1="4.9231" y1="4.37114e-08" x2="4.9231" y2="14.3846" stroke="#2D2D2D" stroke-width="2" />
                                            <line x1="11.4614" y1="2.61536" x2="11.4614" y2="11.7692" stroke="#2D2D2D" stroke-width="2" />
                                        </svg>
                                        <span>Vertical Center</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="middle-right">
                            <div class="slider-container">
                                <button type="button" @click="zoomIn">
                                    <i class="fa-solid fa-plus"></i>
                                </button>
                                <input ref="rangeRef" type="range" class="zoom-range" :min="minScale" :max="maxScale" step="0.1" :model-value="scale" @input="changeZoom($event)" @touchstart="onTouchStart" @touchend="onTouchEnd" @touchcancel="onTouchEnd" />
                                <button type="button" @click="zoomOut">
                                    <i class="fa-solid fa-minus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <MDBRange class="form-range vertical-range" :min="-180" :max="180" /> -->
                    <!-- <div class="left-bottom">

                        </div> -->
                </div>
                <div class="right" v-if="this.store.currentEditingProps.imageToPreview">
                    <MDBModalHeader />
                    <div class="right-top scr-cont">
                        <div class="part-top-btns" style="display: flex; align-items: center; row-gap: 10px;column-gap: 10px;">
                            <button :class="
                    store.currentEditingProps.showEditingTexts == true
                      ? 'top-btn-active'
                      : 'top-btn-inactive'
                  " @click.stop="store.currentEditingProps.showEditingTexts = true">
                                TEXT
                            </button>
                            <button :class="
                    store.currentEditingProps.showEditingTexts == false
                      ? 'top-btn-active'
                      : 'top-btn-inactive'
                  " @click.stop="store.currentEditingProps.showEditingTexts = false">
                                MONOGRAM
                            </button>
                        </div>
                        <template v-if="store.currentEditingProps.showEditingTexts == true">
                            <div id="design-texts-container">
                            <DesignText v-if="store.currentEditingProps.isDesignDst == true" :changeStyleByRef="changeStyleByRef" :increaseTextSize="increaseTextSize" :decreaseTextSize="decreaseTextSize" :changeArc="changeArc" :resetArc="resetArc">
                            </DesignText>
                            <DesignSVGText v-else :changeStyleByRef="changeStyleByRef" :increaseTextSize="increaseTextSize" :decreaseTextSize="decreaseTextSize" :changeArc="changeArc" :resetArc="resetArc">
                            </DesignSVGText>
                            </div>
                        </template>
                        <template v-else>
                            <div id="design-texts-container">
                                <DesignMonogram v-if="store.currentEditingProps.isDesignDst == true"
                                :changeStyleByRef="changeStyleByRef" :increaseMonogramSize="increaseMonogramSize"
                                :decreaseMonogramSize="decreaseMonogramSize" :changeArc="changeArc"
                                :resetArc="resetArc">
                            </DesignMonogram>
                            <span v-else>No monograms to svg</span>
                        </div>
                    </template>
                    </div>
                    <div class="right-middle">
                        <svg width="100%" height="1" viewBox="0 0 100 1" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0" y1="0.5" x2="100" y2="0.5" stroke="#D3D3D3"></line>
                        </svg>
                        <!-- <svg
                :width="'100%'"
                height="1"
                viewBox="0 0 641 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line x1="641" y1="0.5" y2="0.5" stroke="#D3D3D3" />
              </svg> -->
                    </div>
                    <div class="right-bottom">
                            <div class="part-top-btns" style="display: flex; align-items: center; row-gap: 10px;column-gap: 10px;">
                            <button :class="
                    store.currentEditingProps.showEditingArts == true
                      ? 'top-btn-active'
                      : 'top-btn-inactive'
                  " @click.stop="store.currentEditingProps.showEditingArts = true">
                                ARTS
                            </button>
                            <button :class="
                    store.currentEditingProps.showEditingArts == false
                      ? 'top-btn-active'
                      : 'top-btn-inactive'
                  " @click.stop="store.currentEditingProps.showEditingArts = false">
                                UPLOAD ARTS
                            </button>
                            <!-- <span class="art-title">ART CLIP</span> -->
                        </div>
                        <template v-if="store.currentEditingProps.showEditingArts == true">
                            <div id="design-arts-container">
                            <DesignArt v-if="store.currentEditingProps.isDesignDst == true" :changeStyleByRef="changeStyleByRef" :increaseArtSize="increaseArtSize" :decreaseArtSize="decreaseArtSize" :changeArc="changeArc" :resetArc="resetArc">
                            </DesignArt>
                            <DesignSVGArt v-else :changeStyleByRef="changeStyleByRef" :increaseArtSize="increaseArtSize" :decreaseArtSize="decreaseArtSize" :changeArc="changeArc" :resetArc="resetArc">
                            </DesignSVGArt>
                            </div>
                        </template>
                         <template v-else>
                            <div id="design-arts-container">
                           <DesignUserArt v-if="store.currentEditingProps.isDesignDst == true" :changeStyleByRef="changeStyleByRef" :increaseArtSize="increaseUserArtSize" :decreaseArtSize="decreaseUserArtSize" :changeArc="changeArc" :resetArc="resetArc"></DesignUserArt>
                           <DesignSVGUserArt v-else :changeStyleByRef="changeStyleByRef" :increaseArtSize="increaseUserArtSize" :decreaseArtSize="decreaseUserArtSize" :changeArc="changeArc" :resetArc="resetArc"></DesignSVGUserArt>
                            <!-- <DesignSVGArt v-else :changeStyleByRef="changeStyleByRef" :increaseArtSize="increaseArtSize" :decreaseArtSize="decreaseArtSize" :changeArc="changeArc" :resetArc="resetArc">
                            </DesignSVGArt> -->
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="body-bottom">
                <!-- <div class="buttons-flex-full-screan" :style="{'display': smallMobile == true ? 'none' : showBuyBtns}"> -->
                <div class="qty"><span class="product_quantity" >{{ calculatePrice.totalPrice }}</span>
                    <span> NIS</span>
                </div>
                <div v-if="designStatus == 'add-design'" class="buy-btn" @click="buyNow()" >
                    <div class="btn-add buy-now-btn">
                        <span>Buy Now</span>
                        &nbsp;
                        <!-- <img :src="store.baseIconsURL + '//Icons//BuyNowIcon.png'" style="height: 25px" /> -->
                    </div>
                </div>
                <div v-if="designStatus == 'add-design'" class="buy-btn" @click="addToCart()" title="Add to cart" >
    <div class="btn-add add-to-cart-btn" >
        <!-- <template v-if="isAddingToCart"> -->
            <div v-if="isAddingToCart" class="spinner" style="width: 15px; height: 15px; display: block;"></div>
            <!-- <img src="/loading-spinner.gif" style="height: 25px" alt="Loading..." /> -->
        <!-- </template> -->
        <template v-else>
            <span  class="buy-btn">Add To Cart</span>
            &nbsp;
            <!-- <img :src="store.baseIconsURL + '//Icons//AddToCartBlackIcon.png'" style="height: 25px" /> -->
        </template>
    </div>
</div>



                <div v-if="designStatus == 'update-design'" class="update-btn" @click="updateDesign()" title="Update design" style="display: grid; justify-items: center; margin-left: 10px; cursor: pointer;">
                    <div class="btn-add update-des-btn">
                        <span style="color: #FFFFFF">Update Design</span>
                    </div>
                </div>
                <div v-else-if="designStatus == 'manager-update-design'" class="update-btn" @click="managerUpdateDesign()" title="Update design" style="display: grid; justify-items: center; margin-left: 10px; cursor: pointer;">
                    <div class="btn-add manager-update-des-btn">
                        <span style="color: #FFFFFF">Manager Update Design</span>
                    </div>
                </div>
                <!-- </div> -->

                <!-- <span class="sum-txt">179.81 NIS</span>
          <button class="add-to-cart-btn">ADD TO CART</button>
          <button class="buy-now-btn">PAY NOW</button> -->
            </div>
        </div>
    </MDBModalBody>
</MDBModal>
</template>

<script>

import {
    designerStore
} from "@/stores/designerStore";
import {
    userStore
} from "@/stores/userStore";
import { ref } from 'vue'; 
import {
    nextTick
} from "vue-demi";
import {
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBBtn
} from "mdb-vue-ui-kit";
import DesignText from "./DesignComponents/DesignText.vue";
import DesignMonogram from './DesignComponents/DesignMonogram.vue';
import DesignArt from "./DesignComponents/DesignArt.vue";
import DesignSVGArt from "./DesignSVGComponents/DesignSVGArt.vue";
import DesignSVGText from "./DesignSVGComponents/DesignSVGText.vue";
import TextPreview from "./TextPreview.vue";
import MonogramPreview from "./MonogramPreview.vue";
import DSTPreview from "./DSTPreview.vue";
import Moveable from "vue3-moveable";
import DesignUserArt from "./DesignComponents/DesignUserArt.vue";
import DesignSVGUserArt from "./DesignSVGComponents/DesignSVGUserArt.vue";
// import axios from "axios";

export default {
    setup() {
        const store = designerStore();
        const uStore = userStore();
        const openModelToDesign = ref(false);
        const bounds = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            position: "css"
        };
        const userArtsElementsRefs = ref([]);
        const artsElementsRefs = ref([]);
        const textsElementsRefs = ref([]);
        const monogramsElementsRefs = ref([]);

        const rangeRef = ref(null);



        // // נעתיק את האובייקט באופן ריאקטיבי לעריכה
        // const design = reactive({ ...props._designObj })        


        // const elementsMoveableArray = ref([]);
        return {
            store,
            uStore,
            openModelToDesign,
            bounds,
            userArtsElementsRefs,
            artsElementsRefs,
            textsElementsRefs,
            monogramsElementsRefs,
            rangeRef,
        };
    },
    components: {
        MDBModal,
        MDBModalBody,
        MDBModalHeader,
        MDBBtn,
        // MDBRange,
        DesignText,
        DesignMonogram,
        DesignArt,
        DesignUserArt,
        DesignSVGUserArt,
        DesignSVGArt,
        DesignSVGText,
        // VueDraggableResizable,
        TextPreview,
        MonogramPreview,
        DSTPreview,
        Moveable,
    },
    data() {
        return {
            noUsefulImages: false,
            scale: 1,
            translateX: 1,
            translateY: 1,
            showBoundaries: true,
            showCenter: false,
            smallMobile: false,
            smallColorsLine: false,
            rangeValue: 0,
            qty: 1,
            show: false,
            oldDpi: null,
            designStatus: 'add-design',

            maxScale: 1,
            minScale: 0.9,
            bx: 1,
            by: 1,
            bw: 1,
            bh: 1,
            pw: 1,
            ph: 1,
            currentRatio: 1,
            ty: 0,
            tx: 0,
            imgW: 0,
            imgH: 0,
            imgRef: null,
            pictureRef: null,
            isSliding: false,
            moveableRootContainer: null,

            k: 0,
            isAddingToCart: false,
        };
    },
    props: {
        _productId: {
            type: [String], // לפי מה שמתאים לך
            required: true
        },
        _variantId: {
            type: [String],
            required: true
        },
        _designObj: {
            type: Object,
            required: true
        },
        _imgToPreview: {
            type: String,
            required: false
        },
        onManagerUpdateDesign: {
            type: Function,
            required: true
        }
    },
    mounted() {
        window.addEventListener("resize", this.eventHandler);
        this.$nextTick(() => {
            this.moveableRootContainer = this.$refs.imgBoxContainer || null;
        });
    },
    async beforeMount() {
        this.show = true;
        // Cleanup on unmount
        document.body.removeEventListener('touchmove', this.preventScroll)
    },
    async beforeUnmount() {
        window.removeEventListener("resize", this.eventHandler);
    },
    computed: {
        calculatePrice(){
    const t0 = performance.now();
    const result = this.store.calculateDesignPriceNew();
    const t1 = performance.now();
    console.log(`⏱ זמן חישוב: ${(t1 - t0).toFixed(2)}ms`, result);
        // return this.store.calculateDesignPriceNew();
    return result;
    },
    },




    methods: {
        // getMaxScale() {
        //   let maxScale = 1;
        //   let bw = (this.store.getCurrentProduct().box.widthInches * 254 *
        //         this.store.currentEditingProps.dpi) / 254;
        //   let bh = (this.store.getCurrentProduct().box.heightInches * 254 *
        //         this.store.currentEditingProps.dpi) / 254;
        //   // const imgSizeFromHtml = this.$refs.embCanvasCurrent.getBoundingClientRect();
        //   let pw = 322;//imgSizeFromHtml.width;
        //   let ph = 459;//imgSizeFromHtml.height;

        //   if((bw / bh) > (pw / ph)) {
        //     maxScale = pw / bw;
        //   } else {
        //     maxScale = ph / bh;
        //   }
        //   this.maxScale;
        // },
        preventScroll(e) {
            // Only prevent if the touch is inside the input range
            let rangeValue = this.rangeRef.value;
            if (rangeValue && rangeValue.includes(e.target)) {
                e.preventDefault();
            }
        },
        onTouchStart() {
            this.isSliding = true
            document.body.addEventListener('touchmove', this.preventScroll, {
                passive: false
            })
        },
        onTouchEnd() {
            this.isSliding = false
            document.body.removeEventListener('touchmove', this.preventScroll)
        },
        resetScale() {
            // Reset to minScale (fit full image) and recalculate transform
            const transform = this.calculateTransform(this.minScale);
            this.scale = transform.scale;
            this.translateX = transform.x;
            this.translateY = transform.y;
        },
        async getBackgroundImageSize() {
            await nextTick();
            const el = this.$refs['embCanvasCurrent']; //.getBoundingClientRect();
            if (!el) return;

            const bg = window.getComputedStyle(el).backgroundImage;
            const urlMatch = bg.match(/url\(["']?(.+?)["']?\)/);

            if (!urlMatch) return;

            const imageUrl = urlMatch[1];
            const img = new Image();

            img.onload = () => {
                this.imgW = img.naturalWidth;
                this.imgH = img.naturalHeight;
                console.log("Original width:", img.naturalWidth);
                console.log("Original height:", img.naturalHeight);

                // Calculate minScale to fit full image in viewport
                // Make it slightly smaller (0.9) so image appears larger and product is more visible
                if (this.pw > 0 && this.ph > 0 && this.imgW > 0 && this.imgH > 0) {
                    const imageScaleX = this.pw / this.imgW;
                    const imageScaleY = this.ph / this.imgH;
                    const fitScale = Math.min(imageScaleX, imageScaleY);
                    // Make minScale smaller (0.9 factor) so image appears larger - shows product more clearly
                    this.minScale = fitScale * 0.9;
                    // Ensure minScale is at least 0.9 if image is smaller than viewport
                    if (fitScale > 1) {
                        this.minScale = 0.9; // If image is smaller, use a slightly zoomed-in scale
                    }
                    // Ensure minScale doesn't go below a reasonable minimum
                    if (this.minScale < 0.5) this.minScale = 0.5;
                    
                    // If we're at minimum zoom, recalculate transform to center and show product clearly
                    if (Math.abs(this.scale - this.minScale) < 0.01 || this.scale < this.minScale) {
                        this.$nextTick(() => {
                            const transform = this.calculateTransform(this.minScale);
                            this.scale = transform.scale;
                            this.translateX = transform.x;
                            this.translateY = transform.y;
                        });
                    }
                }

                // המשך החישוב
                if (this.pw / this.ph < this.imgW / this.imgH) {
                    this.currentRatio = this.pw / this.imgW;
                    // this.tx = this.pw - (this.pw * this.currentRatio / 2);
                    this.tx = (this.ph - (this.imgH * this.currentRatio)) / 2;
                    this.ty = 0;
                } else {
                    this.currentRatio = this.ph / this.imgH;
                    // this.ty = this.ph - (this.ph * this.currentRatio / 2);
                    this.ty = (this.pw - (this.imgW * this.currentRatio)) / 2;
                    this.tx = 0;
                }

                // You can store or use these values as needed
            };

            img.src = imageUrl;
            // return {
            //   w: img.naturalWidth,
            //   h: img.naturalHeight
            // };
        },
        async calcToZoom() {
            this.moveableRootContainer = this.$refs.imgBoxContainer || null;
            this.bw = ((this.store.getCurrentProduct().box.widthInches * 254 *
                this.store.currentEditingProps.dpi) / 254);
            this.bh = ((this.store.getCurrentProduct().box.heightInches * 254 *
                this.store.currentEditingProps.dpi) / 254);
            // const imgSizeFromHtml = this.$refs.embCanvasCurrent.getBoundingClientRect();
            this.pictureRef = this.$refs.productBoxContainer.getBoundingClientRect();
            this.pw = this.pictureRef.width; //366;//imgSizeFromHtml.width;
            this.ph = this.pictureRef.height; //386;//imgSizeFromHtml.height;

            // var imgContainerRef = this.$refs.imgBoxContainer.getBoundingClientRect(); //imgBoxContainer
            // let imgContainerRefW = imgContainerRef.width;
            // let imgContainerRefH = imgContainerRef.height;

            this.imgRef = this.$refs.embCanvasCurrent.getBoundingClientRect(); //imgBoxContainer
            // let imgW = imgRef.width;
            // let imgH = imgRef.height;
            // console.log('imgW = ', imgW);
            // console.log('imgH = ', imgH);
            await this.getBackgroundImageSize();
            // if(this.pw / this.ph < this.imgW / this.imgH) {
            //   this.currentRatio = this.ph / this.imgH;
            //   this.tx = this.pw - (this.imgW * this.currentRatio / 2);
            //   this.ty = 0;
            // } else {
            //   this.currentRatio = this.pw / this.imgW;
            //   this.ty = this.ph - (this.imgH * this.currentRatio / 2);
            //   this.tx = 0;
            // }

            this.bx = (this.store.getCurrentProduct().box.topLeftDmm.x * (this.store.currentEditingProps.dpi / 254.0));
            this.by = (this.store.getCurrentProduct().box.topLeftDmm.y * (this.store.currentEditingProps.dpi / 254.0));
            // this.bx = (this.store.getCurrentProduct().box.topLeftDmm.x * (this.store.currentEditingProps.dpi / 254.0)) + (this.imgRef.left - this.pictureRef.left);
            // this.by = (this.store.getCurrentProduct().box.topLeftDmm.y * (this.store.currentEditingProps.dpi / 254.0)) + (this.imgRef.top - this.pictureRef.top);
            // Calculate maxScale to fit the box in viewport
            if ((this.bw / this.bh) > (this.pw / this.ph)) {
                this.maxScale = this.pw / this.bw;
            } else {
                this.maxScale = this.ph / this.bh;
            }

            // Calculate minScale to fit the full image in viewport
            // Make it slightly smaller (0.9) so image appears larger and product is more visible
            // Wait for image dimensions to be loaded
            await this.$nextTick();
            if (this.imgW > 0 && this.imgH > 0) {
                const imageScaleX = this.pw / this.imgW;
                const imageScaleY = this.ph / this.imgH;
                const fitScale = Math.min(imageScaleX, imageScaleY);
                // Make minScale smaller (0.9 factor) so image appears larger - shows product more clearly
                this.minScale = fitScale * 0.9;
                // Ensure minScale is at least 0.9 if image is smaller than viewport
                if (fitScale > 1) {
                    this.minScale = 0.9; // If image is smaller, use a slightly zoomed-in scale
                }
                // Ensure minScale doesn't go below a reasonable minimum
                if (this.minScale < 0.5) this.minScale = 0.5;
            } else {
                // Fallback: if image dimensions not loaded, use scale 0.9
                this.minScale = 0.9;
            }

            // Calculate initial transform (use minScale) to center product and show it clearly
            await this.$nextTick();
            if (this.scale <= this.minScale || !this.translateX || !this.translateY) {
                const initialTransform = this.calculateTransform(this.minScale);
                this.scale = initialTransform.scale;
                this.translateX = initialTransform.x;
                this.translateY = initialTransform.y;
            }
        },

        // Calculate transform - always centers the yellow marked area (box) at all zoom levels
        // This keeps the marked area focused and centered in the middle from minScale to maxScale
        calculateTransform(targetScale) {
            const dpi = this.store.currentEditingProps.dpi;
            const box = this.store.getCurrentProduct().box;

            // Get the actual product-box element which contains emb-canvas
            // emb-canvas is absolutely positioned within product-box, so we use product-box as viewport
            const productBox = this.$refs.imgBoxContainer;
            let viewportWidth, viewportHeight;
            
            if (productBox) {
                viewportWidth = productBox.clientWidth || this.pw;
                viewportHeight = productBox.clientHeight || this.ph;
            } else {
                const container = this.$refs.productBoxContainer;
                if (!container) return { scale: this.scale, x: this.translateX, y: this.translateY };
                viewportWidth = container.clientWidth || this.pw;
                viewportHeight = container.clientHeight || this.ph;
            }

            // Box dimensions and position (in pixels at current DPI)
            const boxWidth = box.widthInches * dpi;
            const boxHeight = box.heightInches * dpi;
            const boxX = box.topLeftDmm.x * (dpi / 254.0);
            const boxY = box.topLeftDmm.y * (dpi / 254.0);

            // Always center the yellow marked area (box) at all zoom levels
            // This keeps the marked area focused and centered from minScale to maxScale
            // No switching between image center and box center - always focus on the marked area
            const focusPointX = boxX + boxWidth / 2;
            const focusPointY = boxY + boxHeight / 2;

            // Viewport center (relative to product-box which is the actual container)
            const viewportCenterX = viewportWidth / 2;
            const viewportCenterY = viewportHeight / 2;

            // Calculate translate: ViewportCenter - (BoxCenter * Scale)
            // This centers the yellow marked area (box) at all zoom levels
            // Since transform-origin is 0 0, we calculate from top-left origin
            // The emb-canvas is absolutely positioned, so transforms are relative to its parent (product-box)
            const translateX = viewportCenterX - (focusPointX * targetScale);
            const translateY = viewportCenterY - (focusPointY * targetScale);

            // Debug: Log values to help diagnose issues
            // console.log('calculateTransform:', { targetScale, imageWidth, imageHeight, viewportWidth, viewportHeight, focusPointX, focusPointY, translateX, translateY, isAtMinScale });

            return {
                scale: targetScale,
                x: translateX,
                y: translateY
            };
        },
        changeZoom(e) {
            let newScale = parseFloat(parseFloat(e.target.value).toFixed(1));
            
            // Clamp to valid range (use minScale instead of 1)
            if (newScale < this.minScale) newScale = this.minScale;
            if (newScale > this.maxScale) newScale = this.maxScale;
            
            // Always use calculateTransform
            // At min scale: ensures full image is visible (not cropped)
            // At max scale: centers the yellow box
            const transform = this.calculateTransform(newScale);
            this.scale = transform.scale;
            this.translateX = transform.x;
            this.translateY = transform.y;
        },
        changeZoomBoxStyle() {
            const allControls = document.querySelectorAll('.rCS19atnxs .moveable-control');

            allControls.forEach(control => {
                if (control.closest('.overlay-bd')) {
                    if (this.scale >= this.maxScale * 0.5) {
                        Object.assign(control.style, {
                            width: '6px',
                            height: '6px',
                            'margin-top': '-3px',
                            'margin-left': '-3px',
                            border: '1px solid #fff'
                        });
                    } else if (this.scale >= this.maxScale * 0.3) {
                        Object.assign(control.style, {
                            width: '8px',
                            height: '8px',
                            'margin-top': '-4px',
                            'margin-left': '-4px',
                            border: '1px solid #fff'
                        });
                    } else {
                        Object.assign(control.style, {
                            width: '11px',
                            height: '11px',
                            'margin-top': '-6px',
                            'margin-left': '-6px',
                            border: '2px solid #fff'
                        });
                    }
                }
            });
        },

        updateZoomTransform(newScale) {
            this.$nextTick(() => {
                // Use unified transform calculation
                const transform = this.calculateTransform(newScale);
                this.scale = transform.scale;
                this.translateX = transform.x;
                this.translateY = transform.y;
            });
        },
        async zoomIn() {
            let newScale = parseFloat(parseFloat(this.scale).toFixed(1)) + 0.1;
            
            // Clamp to valid range (use minScale instead of 1)
            if (newScale < this.minScale) newScale = this.minScale;
            if (newScale > this.maxScale) newScale = this.maxScale;
            
            // Always use calculateTransform
            // At min scale: ensures full image is visible (not cropped)
            // At max scale: centers the yellow box
            const transform = this.calculateTransform(newScale);
            this.scale = transform.scale;
            this.translateX = transform.x;
            this.translateY = transform.y;

            // // Ensure we have the latest container dimensions
            // await this.$nextTick();
            
            // // If newScale not provided, calculate it by adding 0.1
            // if (newScale === undefined) {
            //     newScale = Number(this.scale) + 0.1;
            // }
            
            // // Clamp scale to valid range (use minScale instead of 1)
            // if (newScale < this.minScale) newScale = this.minScale;
            // if (newScale > this.maxScale) newScale = this.maxScale;
            // newScale = parseFloat(newScale.toFixed(1));

            // // Calculate transform using unified function
            // const transform = this.calculateTransform(newScale);
            
            // this.scale = transform.scale;
            // this.translateX = transform.x;
            // this.translateY = transform.y;
        },
        // Explicitly zoom to max and center the box
        zoomToMax() {
            const transform = this.calculateTransform(this.maxScale);
            this.scale = transform.scale;
            this.translateX = transform.x;
            this.translateY = transform.y;
        },
        zoomOut() {
            let newScale = parseFloat(parseFloat(this.scale).toFixed(1)) - 0.1;
            
            // Clamp to valid range (use minScale instead of 1)
            if (newScale < this.minScale) newScale = this.minScale;
            if (newScale > this.maxScale) newScale = this.maxScale;
            
            // Always use calculateTransform
            // At min scale: ensures full image is visible (not cropped)
            // At max scale: centers the yellow box
            const transform = this.calculateTransform(newScale);
            this.scale = transform.scale;
            this.translateX = transform.x;
            this.translateY = transform.y;
            // this.changeZoomBoxStyle();

            // // If newScale not provided, calculate it by subtracting 0.1
            // if (newScale === undefined) {
            //     newScale = Number(this.scale) - 0.1;
            // }
            
            // // Clamp scale to valid range (use minScale instead of 1)
            // if (newScale < this.minScale) newScale = this.minScale;
            // newScale = parseFloat(newScale.toFixed(1));

            // // Calculate transform using unified function
            // const transform = this.calculateTransform(newScale);
            
            // this.scale = transform.scale;
            // this.translateX = transform.x;
            // this.translateY = transform.y;
        },
        async eventHandler() {
            var modalWidth =
                this.$refs.modalBodyRef != undefined ?
                this.$refs.modalBodyRef.$el.getBoundingClientRect().width :
                0;
            // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
            if (modalWidth <= 600) {
                this.smallMobile = true;
            } else {
                this.smallMobile = false;
            }

            var colorsWidth =
                this.$refs.colorsSelectLineRef != undefined ?
                this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width :
                0;
            if (colorsWidth <= 300) {
                this.smallColorsLine = true;
            } else {
                this.smallColorsLine = false;
            }
            // this.oldDpi = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
            // this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].dpi; //this.store.currentEditingProps.dpi;
            await this.calculateDpi();
            this.fixElementsDragTransform();
            await this.changeStyleByRef("userArt");
            await this.changeStyleByRef("art");
            await this.changeStyleByRef("monogram");
            await this.changeStyleByRef("text");
            this.calcToZoom();
        },
        fixElementsDragTransform() {
            var arts =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts;
            var texts =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts;
            var monograms =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].monograms;

            Object.values(arts).forEach((art) => {
                this.oldDpi = art.dragTransform.dpi;
                art.dragTransform.width =
                    (((art.dragTransform.width * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                art.dragTransform.height =
                    (((art.dragTransform.height * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                art.dragTransform.x =
                    (((art.dragTransform.x * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                art.dragTransform.y =
                    (((art.dragTransform.y * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                art.dragTransform.dpi = this.store.currentEditingProps.dpi;
            });

            Object.values(texts).forEach((text) => {
                this.oldDpi = text.dragTransform.dpi;
                text.dragTransform.width =
                    (((text.dragTransform.width * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                text.dragTransform.height =
                    (((text.dragTransform.height * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                text.dragTransform.x =
                    (((text.dragTransform.x * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                text.dragTransform.y =
                    (((text.dragTransform.y * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                text.dragTransform.dpi = this.store.currentEditingProps.dpi;
            });
            Object.values(monograms).forEach((monogram) => {
                this.oldDpi = monogram.dragTransform.dpi;
                monogram.dragTransform.width =
                    (((monogram.dragTransform.width * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                monogram.dragTransform.height =
                    (((monogram.dragTransform.height * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                monogram.dragTransform.x =
                    (((monogram.dragTransform.x * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                monogram.dragTransform.y =
                    (((monogram.dragTransform.y * 254) / this.oldDpi) *
                        this.store.currentEditingProps.dpi) /
                    254;
                monogram.dragTransform.dpi = this.store.currentEditingProps.dpi;
            });
        },
        resolveRuntimeProductVariantIds() {
            const globalProductId =
                (typeof window !== "undefined" && window.productId != null && window.productId !== "")
                    ? window.productId
                    : undefined;
            const globalVariantId =
                (typeof window !== "undefined" && window.variantId != null && window.variantId !== "")
                    ? window.variantId
                    : undefined;

            const productId =
                this._productId ||
                this.store.currentEditingProps.productId ||
                globalProductId;
            const variantId =
                this._variantId ||
                this.store.currentEditingProps.variantId ||
                globalVariantId;

            return { productId, variantId };
        },
        async addProductIdToUserDesigns() {
            // this.store.currentEditingProps.productId = "8048603627816";
            // this.store.currentEditingProps.variantId = "44219817165096";

            // this.store.currentEditingProps.productId = "8838828589352";
            // this.store.currentEditingProps.variantId = "47403201626408";

            //עץ
            // this.store.currentEditingProps.productId = "9545584476456";
            // this.store.currentEditingProps.variantId = "49749189951784";

            // //מדבקה
            // this.store.currentEditingProps.productId = "9728575602984";
            // this.store.currentEditingProps.variantId = "50479317254440";

            const { productId, variantId } = this.resolveRuntimeProductVariantIds();
            if (!productId || !variantId) {
                console.error("Missing runtime productId/variantId. Check page globals or component props.");
                return;
            }
            this.store.currentEditingProps.productId = productId;
            this.store.currentEditingProps.variantId = variantId;
            //"variantId":49749189951784,"productId":9545584476456

            const product = await this.store.GetProductInfoByID(
                this.store.currentEditingProps.productId
            );
            this.store.allProducts = JSON.parse(product);
            var currentProduct =
                this.store.allProducts[this.store.currentEditingProps.productId];
            var imageToPreviewObj = Object.values(this.store.getAllProductVariantUsefulImages(
                    this.store.currentEditingProps.productId,
                    this.store.currentEditingProps.variantId))[0];

            if(imageToPreviewObj != undefined) {
                this.store.currentEditingProps = {
                    productId: this.store.currentEditingProps.productId,
                    variantId: Object.values(currentProduct.variants)[0].variantID,
                    isDesignDst: currentProduct.productType == 'Embroidery' || currentProduct.productType == undefined ? true : false,
                    productType: currentProduct.productType == undefined ? 'Embroidery' : currentProduct.productType, //"WoodEngrave", //GlassEngrave //Embroidery //ColorSticker
                    dpi: 45,
                    textPreview: "",
                    imageToPreview: imageToPreviewObj.imageName, //"Black Duffle on Wheels",
                    currentPreviewIndex: -1,
                    currentPreview: "",
                    showEditingTexts: true,
                    showEditingArts: true,
                    changeSelectedArt: false,
                    changeSelectedMonogram: false,
                    newArt: null,
                    newMonogram: null,
                    currentImgPath:  `url(${imageToPreviewObj.file.relativePath.replaceAll("\\", "\\\\")})`                
                    //"", //url(https://cdn.shopify.com/s/files/1/0692/2043/4216/products/bag3.jpg?v=1671543058)",
                };

            // this.store.currentEditingProps.imageToPreview = Object.values(
            //     currentProduct.variants[this.store.currentEditingProps.variantId].images
            // )[0].imageName;

      //       this.store.currentEditingProps.currentImgPath = `url(${currentProduct.variants[
      //   this.store.currentEditingProps.variantId
      // ].images[
      //   this.store.currentEditingProps.imageToPreview
      // ].file.relativePath.replaceAll("\\", "\\\\")})`;

            if (
                this.store.currentEditingProps.productId != undefined &&
                this.store.currentEditingProps.variantId != undefined
            ) {
                this.store.addProductToUserDesign(
                    this.store.currentEditingProps.productId,
                    this.store.currentEditingProps.variantId
                ); // שולח לפונקציה את המספר שהוכנס
            }

            this.exitScroll();
            this.openModelToDesign = true;
            await nextTick();
            this.qty = 1;
            this.designUserModal = true;
            await nextTick();
            var modalWidth =
                this.$refs.modalBodyRef != undefined ?
                this.$refs.modalBodyRef.$el.getBoundingClientRect().width :
                0;
            if (modalWidth <= 600) {
                this.smallMobile = true;
            } else {
                this.smallMobile = false;
            }

            var colorsWidth =
                this.$refs.colorsSelectLineRef != undefined ?
                this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width :
                0;
            if (colorsWidth <= 300) {
                this.smallColorsLine = true;
            } else {
                this.smallColorsLine = false;
            }

            await this.calculateDpi();

            this.fixElementsDragTransform();
            await this.changeStyleByRef("userArt");
            await this.changeStyleByRef("art");
            await this.changeStyleByRef("monogram");
            await this.changeStyleByRef("text");

            if (
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts.length == 0
            ) {
                if (this.store.currentEditingProps.isDesignDst == true) {
                    this.addTextToDesign();
                } else {
                    this.addTextSVGToDesign();
                }
            } else {
                this.store.currentEditingProps.currentPreviewIndex =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].texts.length - 1;
            }
            await this.changeStyleByRef("userArt");
            await this.changeStyleByRef("art");
            await this.changeStyleByRef("monogram");
            await this.changeStyleByRef("text");
            this.store.currentEditingProps.currentPreview = "text";

            this.calcToZoom();
            } else {
                this.openModelToDesign = true;
                await nextTick();
                this.qty = 1;
                this.designUserModal = true;
                await nextTick();
                var modalWidth2 =
                    this.$refs.modalBodyRef != undefined ?
                    this.$refs.modalBodyRef.$el.getBoundingClientRect().width :
                    0;
                if (modalWidth2 <= 600) {
                    this.smallMobile = true;
                } else {
                    this.smallMobile = false;
                }

                var colorsWidth2 =
                    this.$refs.colorsSelectLineRef != undefined ?
                    this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width :
                    0;
                if (colorsWidth2 <= 300) {
                    this.smallColorsLine = true;
                } else {
                    this.smallColorsLine = false;
                }

                this.noUsefulImages = true;
            }
            document.getElementById('input-add-status').value = 'ready';
        },
        async changeStyleByRef(type) {
            this.selectElementToPreview(type, this.store.currentEditingProps.currentPreviewIndex)
            if (type == "text") {
                await nextTick();
                var index = 0;
                this.textsElementsRefs.forEach((el) => {
                    var textObjectToShow =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].texts[index];
                    if (el != null) {
                        // Round values to prevent sub-pixel rendering issues for smoother performance
                        var x = Math.round(textObjectToShow.dragTransform.x * 100) / 100;
                        var y = Math.round(textObjectToShow.dragTransform.y * 100) / 100;
                        var scaleX = Math.round(textObjectToShow.dragTransform.scale.scaleX * 1000) / 1000;
                        var scaleY = Math.round(textObjectToShow.dragTransform.scale.scaleY * 1000) / 1000;
                        var rotate = Math.round(textObjectToShow.dragTransform.rotate * 100) / 100;
                        var width = Math.round(textObjectToShow.dragTransform.width * 100) / 100;
                        var height = Math.round(textObjectToShow.dragTransform.height * 100) / 100;
                        
                        // Use will-change for better performance during resize
                        el.style.willChange = 'transform, width, height';
                        
                        // Apply transform and dimensions in a single operation for better performance
                        el.style.transform = `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY}) rotate(${rotate}deg)`;
                        el.style.width = `${width}px`;
                        el.style.height = `${height}px`;
                        
                        // Remove will-change after a short delay to allow browser optimization
                        setTimeout(() => {
                            if (el) {
                                el.style.willChange = 'auto';
                            }
                        }, 100);
                    }
                    index++;
                });
            } else if (type == "art") {
                await nextTick();
                index = 0;
                this.artsElementsRefs.forEach((el) => {
                    var artObjectToShow =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].arts[index];
                    if (el != null) {
                        var x = artObjectToShow.dragTransform.x;
                        var y = artObjectToShow.dragTransform.y;
                        el.style.transform = `translate(${x}px, ${y}px) scale(${artObjectToShow.dragTransform.scale.scaleX}, ${artObjectToShow.dragTransform.scale.scaleY}) rotate(${artObjectToShow.dragTransform.rotate}deg)`;
                        el.style.height = `${artObjectToShow.dragTransform.height}px`;
                        el.style.width = `${artObjectToShow.dragTransform.width}px`;
                    }
                    index++;
                });
            } else if(type == "userArt") {
                await nextTick();
                index = 0;
                this.userArtsElementsRefs.forEach((el) => {
                    var userArtObjectToShow =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].userArts[index];
                    if (el != null) {
                        var x = userArtObjectToShow.dragTransform.x;
                        var y = userArtObjectToShow.dragTransform.y;
                        el.style.transform = `translate(${x}px, ${y}px) scale(${userArtObjectToShow.dragTransform.scale.scaleX}, ${userArtObjectToShow.dragTransform.scale.scaleY}) rotate(${userArtObjectToShow.dragTransform.rotate}deg)`;
                        el.style.height = `${userArtObjectToShow.dragTransform.height}px`;
                        el.style.width = `${userArtObjectToShow.dragTransform.width}px`;
                    }
                    index++;
                });
            } else if (type == "monogram") {
                await nextTick();
                index = 0;
                this.monogramsElementsRefs.forEach((el) => {
                    var monogramObjectToShow =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].monograms[index];
                    if (el != null) {
                        var x = monogramObjectToShow.dragTransform.x; // * (this.store.currentEditingProps.dpi / 254);
                        var y = monogramObjectToShow.dragTransform.y; // * (this.store.currentEditingProps.dpi / 254);
                        el.style.transform = `translate(${x}px, ${y}px) scale(${monogramObjectToShow.dragTransform.scale.scaleX}, ${monogramObjectToShow.dragTransform.scale.scaleY}) rotate(${monogramObjectToShow.dragTransform.rotate}deg)`;

                        el.style.height = `${monogramObjectToShow.dragTransform.height}px`;
                        el.style.width = `${monogramObjectToShow.dragTransform.width}px`;
                    }
                    index++;
                });
            }
        },
        selectElementToPreview(type, index) {
            this.showCenter = true;
            if (type == "text") {
                this.store.currentEditingProps.showEditingTexts = true;
            } else if (type == "art") {
                this.store.currentEditingProps.showEditingArts = true;
            } else if(type == "userArt") {
                this.store.currentEditingProps.showEditingArts = false;
            } else if (type == "monogram") {
                this.store.currentEditingProps.showEditingTexts = false;
            }
            this.store.currentEditingProps.currentPreviewIndex = index;
            this.store.currentEditingProps.currentPreview = type;
        },
        addTextToDesign() {
            var fontObj = this.store.getAllFontsWithoutMaterials()[0];
            (this.store.currentEditingProps.textPreview = {
                imageName: this.store.currentEditingProps.imageToPreview,
                text: "",
                fontID: fontObj.fontID,
                fontSizeID: Object.values(this.store.getAllFontSizes(fontObj.fontID))[0].sizeID,
                //layersColors: fontObj.defaultFontColors || this.store.getDefaultColorArray(fontObj.layerCount || 1),
                layersColors: [...fontObj.defaultFontColors] || this.store.getDefaultColorArray(fontObj.layerCount || 1),
          
                //colorID: this.store.blackColorIdDst,
                textArc: 0,
                location: {
                    x: 0,
                    y: 0,
                    arc: 0
                },
            }),
            console.log(this.store.currentEditingProps.textPreview.layersColors);
            this.store.addTextToDesign(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.textPreview
            );
            this.store.currentEditingProps.currentPreviewIndex =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts.length - 1;
            this.store.currentEditingProps.currentPreview = "text";
        },
        addTextSVGToDesign() {
            this.store.currentEditingProps.textPreview = {
                imageName: this.store.currentEditingProps.imageToPreview,
                text: "",
                fontID: this.store.getAllFontsFiles()[0].fontID,
                layersColors: this.store.currentEditingProps.productType != "WoodEngrave" &&
                    this.store.currentEditingProps.productType != "GlassEngrave" ?
                    this.store
                    .getAllSVGColors()
                    .slice(0, 1)
                    .map((m) => m.colorID) :
                    [this.store.blackForWoodAndGlassId],
                textArc: 0,
                location: {
                    x: 0,
                    y: 0,
                    arc: 0
                },
            };
            this.store.addTextSVGToDesign(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                this.store.currentEditingProps.textPreview
            );
            this.store.currentEditingProps.currentPreviewIndex =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts.length - 1;
            this.store.currentEditingProps.currentPreview = "text";
        },
        async changeImg(image) {
            this.store.currentEditingProps.imageToPreview = image.imageName;
            this.store.currentEditingProps.currentImgPath = `url(${image.file.relativePath.replaceAll(
        "\\",
        "\\\\"
      )})`;

            if (
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts.length == 0
            ) {
                if(this.store.currentEditingProps.isDesignDst == true) {
                    this.addTextToDesign();
                } else {
                    this.addTextSVGToDesign();
                }
            }
            // else {
            //   this.store.currentEditingProps.currentPreviewIndex =
            //     this.uStore.userDesigns[this.store.currentEditingProps.productId]
            //       .designs[this.store.currentEditingProps.variantId].imgVariants[
            //       this.store.currentEditingProps.imageToPreview
            //     ].texts.length - 1;
            // }
            // this.store.currentEditingProps.currentPreview = "text";
            this.store.currentEditingProps.currentPreview = null;
            // this.exitScroll();
            await this.calculateDpi();

            await this.changeStyleByRef("userArt");
            await this.changeStyleByRef("art");
            await this.changeStyleByRef("monogram");
            await this.changeStyleByRef("text");
            this.calcToZoom();
        },
        async calculateDpi() {
            // console.log("calculateDpi function");
            if (this.store.currentEditingProps.imageToPreview != null) {
                await nextTick();
                const imgSizeFromHtml =
                    this.$refs.embCanvasCurrent.getBoundingClientRect();
                var imgRatioFromHtml = imgSizeFromHtml.width / imgSizeFromHtml.height;
                var imgRatio =
                    this.store.getCurrentProduct().imgWidthInches /
                    this.store.getCurrentProduct().imgHeightInches;
                var width =
                    imgRatio < imgRatioFromHtml ?
                    this.store.getCurrentProduct().imgWidthInches *
                    (imgSizeFromHtml.height /
                        this.store.getCurrentProduct().imgHeightInches) :
                    imgSizeFromHtml.width;

                this.store.currentEditingProps.dpi =
                    width / this.store.getCurrentProduct().imgWidthInches;
            }
        },
        exitScroll() {
            this.store.currentEditingProps.currentPreviewIndex = -1;
            this.showCenter = false;
        },
        getStyleByTransform(transformString, width, height) {
            // Extract the translate values (x and y)
            var translateMatch = transformString.match(
                /translate\(([^,]+), ([^)]+)\)/
            );
            var x = translateMatch ? parseFloat(translateMatch[1]) : 0;
            var y = translateMatch ? parseFloat(translateMatch[2]) : 0;

            // Extract the scale values
            var scaleMatch = transformString.match(/scale\(([^,]+), ([^)]+)\)/);
            var scaleX = scaleMatch ? parseFloat(scaleMatch[1]) : 1;
            var scaleY = scaleMatch ? parseFloat(scaleMatch[2]) : 1;

            // Extract the rotate value
            var rotateMatch = transformString.match(/rotate\(([^)]+)deg\)/);
            var rotate = rotateMatch ? parseFloat(rotateMatch[1]) : 0;

            var topX = width * scaleX - x < 0 ? 0 : width * scaleX - x;
            var topY = height * scaleY - y < 0 ? 0 : height * scaleY - y;
            var result = {
                // 'x': (x + (1 - scaleX) * width * 0.5), // * 254 / this.store.currentEditingProps.dpi, //x - ((1 - scaleX) * width),
                // 'y': (y + (1 - scaleY) * height * 0.5), // * 254 / this.store.currentEditingProps.dpi, //y - ((1 - scaleY) * height),
                x: x,
                y: y,
                width: width,
                height: height,
                scale: {
                    scaleX: scaleX,
                    scaleY: scaleY,
                },
                rotate: rotate,
                topX: topX,
                topY: topY,
                dpi: this.store.currentEditingProps.dpi,
            };
            return result;
        },
        async onDrag(e, type, index) {
            this.selectElementToPreview(type, index);
            var obj = null;
            if (type == "text") {

                obj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].texts[index];
                var trans = this.getStyleByTransform(e.transform, e.width, e.height); // * 254 / this.store.currentEditingProps.dpi
                obj.dragTransform = trans;
                await this.changeStyleByRef("text");
            } else if (type == "art") {
                obj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index];

                trans = this.getStyleByTransform(e.transform, e.width, e.height);
                obj.dragTransform = trans;

                await this.changeStyleByRef("art");
            } else if(type == "userArt") {
                obj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].userArts[index];

                trans = this.getStyleByTransform(e.transform, e.width, e.height);
                obj.dragTransform = trans;

                await this.changeStyleByRef("userArt");
            } else if (type == "monogram") {
                obj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].monograms[index];
                trans = this.getStyleByTransform(e.transform, e.width, e.height);
                obj.dragTransform = trans;
                await this.changeStyleByRef("monogram");
            }
        },
        async onScale(e, type, index) {
            var trans = null;
            this.selectElementToPreview(type, index);
            var obj = null;
            if (type == "text") {
                trans = this.getStyleByTransform(
                    e.transform,
                    this.extractFloatNumber(e.target.style.width),
                    this.extractFloatNumber(e.target.style.height)
                ); // * 254 / this.store.currentEditingProps.dpi

                if (this.store.currentEditingProps.isDesignDst == true) {
                    obj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].texts[index];
                    // var height = this.extractFloatNumber(e.target.style.height) * trans.scale.scaleY;
                    var width =
                        this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;
                    // var width = this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;
                    if (
                        width >= this.getMinWidthTextSize(obj.fontID, obj.text) &&
                        width <= this.getMaxWidthTextSize(obj.fontID, obj.text)
                    ) {
                        // e.target.style.transform = e.drag.transform;
                        this.uStore.userDesigns[
                            this.store.currentEditingProps.productId
                        ].designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].texts[index].dragTransform = trans;

                        await this.changeStyleByRef("text");
                    }
                } else {
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].texts[index].dragTransform = trans;
                    await this.changeStyleByRef("text");
                }
            } else if (type == "art") {
                trans = this.getStyleByTransform(
                    e.transform,
                    this.extractFloatNumber(e.target.style.width),
                    this.extractFloatNumber(e.target.style.height)
                );

                if (this.store.currentEditingProps.isDesignDst == true) {
                    obj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].arts[index];
                    width =
                        this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;
                    if (
                        width >= this.getMinWidthArtSize(obj.artID) &&
                        width <= this.getMaxWidthArtSize(obj.artID)
                    ) {
                        // e.target.style.transform = e.drag.transform;
                        this.uStore.userDesigns[
                            this.store.currentEditingProps.productId
                        ].designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].arts[index].dragTransform = trans;

                        await this.changeStyleByRef("art");
                    }
                } else {
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform = trans;
                    await this.changeStyleByRef("art");
                }
            } else if(type == "userArt") {
                trans = this.getStyleByTransform(
                    e.transform,
                    this.extractFloatNumber(e.target.style.width),
                    this.extractFloatNumber(e.target.style.height)
                );

                if (this.store.currentEditingProps.isDesignDst == true) {
                    obj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].userArts[index];
                    width =
                        this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;
                    
                    var boxWidth =
                    (this.store.getCurrentProduct().box.heightInches *
                        254 *
                        this.store.currentEditingProps.dpi) /
                    254;
                    
                        if (
                        width >= 1 && // this.getMinWidthArtSize(obj.artID) &&
                        width <= boxWidth // this.getMaxWidthArtSize(obj.artID)
                    ) {
                        // e.target.style.transform = e.drag.transform;
                        this.uStore.userDesigns[
                            this.store.currentEditingProps.productId
                        ].designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].userArts[index].dragTransform = trans;

                        await this.changeStyleByRef("userArt");
                    }
                } else {
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].userArts[index].dragTransform = trans;
                    await this.changeStyleByRef("userArt");
                }
            } else if (type == "monogram") {
                trans = this.getStyleByTransform(
                    e.transform,
                    this.extractFloatNumber(e.target.style.width),
                    this.extractFloatNumber(e.target.style.height)
                );
                obj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].monograms[index];
                width =
                    this.extractFloatNumber(e.target.style.width) * trans.scale.scaleX;
                // if (width >= this.getMinWidthMonogramSize(obj) && width <= this.getMaxWidthMonogramSize(obj)) {
                // e.target.style.transform = e.drag.transform;
                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].monograms[index].dragTransform = trans;

                await this.changeStyleByRef("monogram");
            }
        },
        async onScaleEnd(e, type, index) {
            if (type == "text" && this.store.currentEditingProps.isDesignDst == true) {
                try {
                    var textObj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].texts[index];

                    if (!textObj || !textObj.dragTransform) {
                        console.warn('onScaleEnd: Text object not found at index', index);
                        return;
                    }

                    // Get the current transform from the event or use existing
                    var currentTransform = textObj.dragTransform;
                    
                    var newTextSizeObj = this.store.findingNearestFontSize(
                        textObj,
                        this.store.currentEditingProps.dpi
                    );

                    // Calculate new dimensions based on the nearest font size
                    var newTextWidth =
                        (this.store.getTextLength(
                                textObj.text,
                                textObj.fontID,
                                newTextSizeObj.sizeID
                            ) *
                            newTextSizeObj.scale *
                            this.store.currentEditingProps.dpi) /
                        254;
                    var newTextHeight =
                        (this.store.getMaxTextHeight(
                                textObj.text,
                                textObj.fontID,
                                newTextSizeObj.sizeID
                            ) *
                            newTextSizeObj.scale *
                            this.store.currentEditingProps.dpi) /
                        254;

                    // Calculate center point for repositioning
                    const oldWidth = currentTransform.width;
                    const oldHeight = currentTransform.height;
                    const centerX = currentTransform.x + oldWidth * 0.5;
                    const centerY = currentTransform.y + oldHeight * 0.5;

                    // Update all transform properties
                    const productId = this.store.currentEditingProps.productId;
                    const variantId = this.store.currentEditingProps.variantId;
                    const imageToPreview = this.store.currentEditingProps.imageToPreview;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.scale.scaleX = newTextSizeObj.scale;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.scale.scaleY = newTextSizeObj.scale;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].fontSizeID = newTextSizeObj.sizeID;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.width = newTextWidth;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.height = newTextHeight;
                    
                    // Reposition to keep center point fixed
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.x = centerX - newTextWidth * 0.5;
                    
                    this.uStore.userDesigns[productId]
                        .designs[variantId]
                        .imgVariants[imageToPreview]
                        .texts[index].dragTransform.y = centerY - newTextHeight * 0.5;
                    
                    await this.changeStyleByRef("text");
                } catch (error) {
                    console.error('Error in onScaleEnd for text:', error);
                }
            } else if (type == "art" && this.store.currentEditingProps.isDesignDst == true) {
                var artObj =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index];

                var newArtSizeObj = this.store.findingNearestArtSize(
                    artObj,
                    this.store.currentEditingProps.dpi
                );
                var newArtWidth =
                    (this.store.allArts.value[artObj.artID].sizes[newArtSizeObj.sizeID]
                        .dstfile.pixelWidth *
                        newArtSizeObj.scale *
                        this.store.currentEditingProps.dpi) /
                    254;
                var newArtHeight =
                    (this.store.allArts.value[artObj.artID].sizes[newArtSizeObj.sizeID]
                        .dstfile.pixelHeight *
                        newArtSizeObj.scale *
                        this.store.currentEditingProps.dpi) /
                    254;

                this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform.x =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform.x +
                    (artObj.dragTransform.width - newArtWidth) / 2;

                this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform.y =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform.y +
                    (artObj.dragTransform.height - newArtHeight) / 2;

                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].dragTransform.scale.scaleX = newArtSizeObj.scale;

                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].dragTransform.scale.scaleY = newArtSizeObj.scale;

                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].artSizeID = newArtSizeObj.sizeID;

                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].dragTransform.width = newArtWidth;

                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].dragTransform.height = newArtHeight;

                this.changeStyleByRef("art");
            }
        },
        async onRotate(e, type, index) {
            var trans = this.getStyleByTransform(
                e.transform,
                this.extractFloatNumber(e.target.style.width),
                this.extractFloatNumber(e.target.style.height)
            );
            this.selectElementToPreview(type, index);
            if (type == "text") {
                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].texts[index].dragTransform = trans;

                await this.changeStyleByRef("text");
            } else if (type == "art") {
                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index].dragTransform = trans;

                await this.changeStyleByRef("art");
            } else if (type == "userArt") {
                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].userArts[index].dragTransform = trans;

                await this.changeStyleByRef("userArt");
            } else if (type == "monogram") {
                this.uStore.userDesigns[
                    this.store.currentEditingProps.productId
                ].designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].monograms[index].dragTransform = trans;

                await this.changeStyleByRef("monogram");
            }
        },
        extractFloatNumber(originalString) {
            //"31.5591px" -> 31.5591
            const match = originalString.match(/[\d.]+/);
            return match ? parseFloat(match[0]) : 0;
        },
        getMinWidthTextSize(fontId, text) {
            var sizesList = Object.values(
                this.store.getAllTextSizesWithVirtualSizes(fontId, text)
            ).map((m) => this.store.getTextLength(text, fontId, m.sizeID) * m.scale); //.map(m => this.store.allFonts.value[fontId].sizes[m.sizeID].FontHeight * m.scale);
            return (
                (Math.min(...sizesList) * this.store.currentEditingProps.dpi) / 254
            );
        },
        getMaxWidthTextSize(fontId, text) {
            // var sizesList = Object.values(this.store.getAllTextSizesWithVirtualSizes(fontId)).map(m => this.store.getMaxTextHeight(text, fontId, m.sizeID) * m.scale)//this.store.allFonts.value[fontId].sizes[m.sizeID].FontHeight * m.scale); //.map(m => m.FontHeight);
            var sizesList = Object.values(
                this.store.getAllTextSizesWithVirtualSizes(fontId, text)
            ).map((m) => this.store.getTextLength(text, fontId, m.sizeID) * m.scale); //this.store.allFonts.value[fontId].sizes[m.sizeID].FontHeight * m.scale); //.map(m => m.FontHeight);
            // var sizesList = Object.values(this.store.getTextWidthByAllSizes(fontId, text)); //.map(m => m.FontHeight);
            return (
                (Math.max(...sizesList) * this.store.currentEditingProps.dpi) / 254
            );
        },
        getMinWidthArtSize(artId) {
            var sizesList = Object.values(
                this.store.getAllArtSizesWithVirtualSizes(artId)
            ).map(
                (m) =>
                this.store.allArts.value[artId].sizes[m.sizeID].dstfile.pixelWidth *
                m.scale
            );
            // var sizesList = Object.values(this.store.getAllArtSizes(artId)).map(m => m.dstfile.pixelWidth);
            return (
                (Math.min(...sizesList) * this.store.currentEditingProps.dpi) / 254
            );
        },
        getMaxWidthArtSize(artId) {
            var sizesList = Object.values(
                this.store.getAllArtSizesWithVirtualSizes(artId)
            ).map(
                (m) =>
                this.store.allArts.value[artId].sizes[m.sizeID].dstfile.pixelWidth *
                m.scale
            );
            // var sizesList = Object.values(this.store.getAllArtSizesWithVirtualSizes(artId)).map(m => m.dstfile.pixelWidth);
            return (
                (Math.max(...sizesList) * this.store.currentEditingProps.dpi) / 254
            );
        },

        fixHorizontalOrVertical(type) {
            console.log("cha");
            var designs =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ];

            //גודל הריבוע שתופס את האלמנט הבחור
            var dragBoxHeight = 0;
            var dragBoxWidth = 0;
            var objectToMove = {};

            if (this.store.currentEditingProps.currentPreview == "text") {
                objectToMove =
                    this.store.getUserDesignsTextsContentful()[
                        this.store.currentEditingProps.currentPreviewIndex
                    ];
            } else if (this.store.currentEditingProps.currentPreview == "art") {
                objectToMove =
                    designs.arts[this.store.currentEditingProps.currentPreviewIndex];
            } else {
                objectToMove =
                    designs.monograms[this.store.currentEditingProps.currentPreviewIndex];
            }

            dragBoxHeight = objectToMove.dragSize.h;
            dragBoxWidth = objectToMove.dragSize.w;
            if (type == "Vertical") {
                //Vertical - לרוחב
                //גודל הקופסא של המוצר
                var boxHeight =
                    (this.store.getCurrentProduct().box.heightInches *
                        254 *
                        this.store.currentEditingProps.dpi) /
                    254;
                var artHeight =
                    objectToMove.dragTransform.scale.scaleY *
                    objectToMove.dragTransform.height;
                objectToMove.location.y = (boxHeight - artHeight) / 2;
                objectToMove.dragLocation.y = (boxHeight - dragBoxHeight) / 2;
                objectToMove.dragTransform.y = (boxHeight - artHeight) / 2;
            } else {
                //לגובה
                //גודל הקופסא של המוצר
                var boxWidth =
                    (this.store.getCurrentProduct().box.widthInches *
                        254 *
                        this.store.currentEditingProps.dpi) /
                    254;
                var artWidth =
                    objectToMove.dragTransform.scale.scaleX *
                    objectToMove.dragTransform.width;
                objectToMove.location.x = (boxWidth - artWidth) / 2;
                objectToMove.dragLocation.x = (boxWidth - dragBoxWidth) / 2; // - (dragBoxWidth / 2);
                objectToMove.dragTransform.x = (boxWidth - artWidth) / 2;
            }

            //מסדר את המיקום לגמרי גם ב
            //location
            if (this.store.currentEditingProps.currentPreview == "text") {
                this.changeStyleByRef("text");
            } else if (this.store.currentEditingProps.currentPreview == "art") {
                this.changeStyleByRef("art");
            } else {
                objectToMove.location = this.store.getMonogramLocation(
                    this.store.allMonograms.value[objectToMove.monogramID],
                    objectToMove.distance1,
                    objectToMove.distance2,
                    objectToMove.align,
                    objectToMove.leftChar,
                    objectToMove.middleChar,
                    objectToMove.rightChar,
                    objectToMove.dragLocation.x,
                    objectToMove.dragLocation.y
                ).location;
            }
        },
        increaseArtSize(index) {
            var artDesignObj =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index];
            if (this.store.currentEditingProps.isDesignDst == true) {
                var next = this.store.findingNextVirtualArtSize(
                    artDesignObj,
                    this.store.currentEditingProps.dpi
                );
                // Check if next size exists before using it
                if (next && next.sizeID !== undefined) {
                    artDesignObj.artSizeID = next.sizeID;
                    artDesignObj.dragTransform.scale.scaleX = next.scale;
                    artDesignObj.dragTransform.scale.scaleY = next.scale;
                    artDesignObj.dragTransform.width =
                        (this.store.allArts.value[artDesignObj.artID].sizes[
                                artDesignObj.artSizeID
                            ].dstfile.pixelWidth *
                            this.store.currentEditingProps.dpi) /
                        254;
                    artDesignObj.dragTransform.height =
                        (this.store.allArts.value[artDesignObj.artID].sizes[
                                artDesignObj.artSizeID
                            ].dstfile.pixelHeight *
                            this.store.currentEditingProps.dpi) /
                        254;
                }
                // If next is undefined, it means we're already at maximum size, so do nothing
            } else {
                artDesignObj.dragTransform.scale.scaleX += 0.2;
                artDesignObj.dragTransform.scale.scaleY += 0.2;
            }
            this.changeStyleByRef("art");
        },
        async decreaseArtSize(index) {
            //שומר את הפיקסלים של הגודל הנוכחי לפי הסקייל כי אולי מתח ידנית
            var artDesignObj =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].arts[index];
            if (this.store.currentEditingProps.isDesignDst == true) {
                var previous = this.store.findingPreviouVirtualArtSize(
                    artDesignObj,
                    this.store.currentEditingProps.dpi
                );
                // Check if previous size exists before using it
                if (previous && previous.sizeID !== undefined) {
                    artDesignObj.artSizeID = previous.sizeID;
                    artDesignObj.dragTransform.scale.scaleX = previous.scale;
                    artDesignObj.dragTransform.scale.scaleY = previous.scale;
                    artDesignObj.dragTransform.width =
                        (this.store.allArts.value[artDesignObj.artID].sizes[
                                artDesignObj.artSizeID
                            ].dstfile.pixelWidth *
                            this.store.currentEditingProps.dpi) /
                        254;
                    artDesignObj.dragTransform.height =
                        (this.store.allArts.value[artDesignObj.artID].sizes[
                                artDesignObj.artSizeID
                            ].dstfile.pixelHeight *
                            this.store.currentEditingProps.dpi) /
                        254;
                }
                // If previous is undefined, it means we're already at minimum size, so do nothing
            } else {
                artDesignObj.dragTransform.scale.scaleX -= 0.2;
                artDesignObj.dragTransform.scale.scaleY -= 0.2;
            }
            await this.changeStyleByRef("art");
        },
        increaseUserArtSize(index) {
            var userArtDesignObj =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].userArts[index];
            // For userArts, just increase the scale
            userArtDesignObj.dragTransform.scale.scaleX += 0.2;
            userArtDesignObj.dragTransform.scale.scaleY += 0.2;
            this.changeStyleByRef("userArt");
        },
        async decreaseUserArtSize(index) {
            var userArtDesignObj =
                this.uStore.userDesigns[this.store.currentEditingProps.productId]
                .designs[this.store.currentEditingProps.variantId].imgVariants[
                    this.store.currentEditingProps.imageToPreview
                ].userArts[index];
            // For userArts, just decrease the scale (with minimum check)
            if (userArtDesignObj.dragTransform.scale.scaleX > 0.2) {
                userArtDesignObj.dragTransform.scale.scaleX -= 0.2;
                userArtDesignObj.dragTransform.scale.scaleY -= 0.2;
            }
            await this.changeStyleByRef("userArt");
        },
        async increaseTextSize(index) {
            const productId = this.store.currentEditingProps.productId;
            const variantId = this.store.currentEditingProps.variantId;
            const imageToPreview = this.store.currentEditingProps.imageToPreview;

            // Validate index and object existence
            if (index === undefined || index === null || index < 0) {
                console.warn('increaseTextSize: Invalid index', index);
                return;
            }

            const textDesignObj =
                this.uStore.userDesigns[productId]
                ?.designs[variantId]
                ?.imgVariants[imageToPreview]
                ?.texts[index];

            if (!textDesignObj || !textDesignObj.dragTransform) {
                console.warn('increaseTextSize: Text object not found at index', index);
                return;
            }

            // Debug: Log current state
            if (process.env.NODE_ENV === 'development') {
                console.log('increaseTextSize called for index:', index, 'Current scale:', textDesignObj.dragTransform.scale?.scaleX);
            }

            // Ensure scale object exists
            if (!textDesignObj.dragTransform.scale) {
                textDesignObj.dragTransform.scale = { scaleX: 1.0, scaleY: 1.0 };
            }

            const MAX_SCALE = 3.0;
            const currentScale = textDesignObj.dragTransform.scale.scaleX || 1.0;
            
            // Prevent resize if already at max
            if (currentScale >= MAX_SCALE) {
                return;
            }
            
            const nextScale = Math.min(currentScale + 0.1, MAX_SCALE);
            const scaleRatio = nextScale / currentScale;

            // Store current dimensions and position for smooth calculation
            let oldWidth = textDesignObj.dragTransform.width || 0;
            let oldHeight = textDesignObj.dragTransform.height || 0;
            const oldX = textDesignObj.dragTransform.x || 0;
            const oldY = textDesignObj.dragTransform.y || 0;

            // If width/height are 0 or invalid, calculate them from base dimensions
            if (oldWidth <= 0 || oldHeight <= 0 || isNaN(oldWidth) || isNaN(oldHeight)) {
                if (this.store.currentEditingProps.isDesignDst === true) {
                    const baseTextLength = this.store.getTextLength(
                        textDesignObj.text,
                        textDesignObj.fontID,
                        textDesignObj.fontSizeID
                    );
                    const baseTextHeight = this.store.getMaxTextHeight(
                        textDesignObj.text,
                        textDesignObj.fontID,
                        textDesignObj.fontSizeID
                    );
                    const dpiFactor = this.store.currentEditingProps.dpi / 254;
                    oldWidth = baseTextLength * currentScale * dpiFactor;
                    oldHeight = baseTextHeight * currentScale * dpiFactor;
                } else {
                    // For SVG, use a default size if not available
                    oldWidth = oldWidth || 100;
                    oldHeight = oldHeight || 50;
                }
            }

            // Calculate center point (since transform-origin is 0 0)
            // Use precise calculations to avoid rounding errors
            const centerX = oldX + oldWidth * 0.5;
            const centerY = oldY + oldHeight * 0.5;

            // Update scale with precision
            textDesignObj.dragTransform.scale.scaleX = nextScale;
            textDesignObj.dragTransform.scale.scaleY = nextScale;

            // Recalculate width and height based on the new scale
            if (this.store.currentEditingProps.isDesignDst === true) {
                // For DST mode: calculate based on text length and font size
                const baseTextLength = this.store.getTextLength(
                    textDesignObj.text,
                    textDesignObj.fontID,
                    textDesignObj.fontSizeID
                );
                const baseTextHeight = this.store.getMaxTextHeight(
                    textDesignObj.text,
                    textDesignObj.fontID,
                    textDesignObj.fontSizeID
                );
                const dpiFactor = this.store.currentEditingProps.dpi / 254;
                
                const newTextWidth = baseTextLength * nextScale * dpiFactor;
                const newTextHeight = baseTextHeight * nextScale * dpiFactor;

                // Update dimensions with precision
                textDesignObj.dragTransform.width = newTextWidth;
                textDesignObj.dragTransform.height = newTextHeight;

                // Reposition to keep center point fixed (precise calculation)
                textDesignObj.dragTransform.x = centerX - newTextWidth * 0.5;
                textDesignObj.dragTransform.y = centerY - newTextHeight * 0.5;
            } else {
                // For SVG mode: scale width and height proportionally
                const newWidth = oldWidth * scaleRatio;
                const newHeight = oldHeight * scaleRatio;

                textDesignObj.dragTransform.width = newWidth;
                textDesignObj.dragTransform.height = newHeight;

                // Reposition to keep center point fixed (precise calculation)
                textDesignObj.dragTransform.x = centerX - newWidth * 0.5;
                textDesignObj.dragTransform.y = centerY - newHeight * 0.5;
            }

            // Update immediately for smooth resize
            if (process.env.NODE_ENV === 'development') {
                console.log('increaseTextSize: Updated scale to', nextScale, 'New dimensions:', textDesignObj.dragTransform.width, textDesignObj.dragTransform.height);
            }
            await this.changeStyleByRef("text");
        },

        async decreaseTextSize(index) {
            const productId = this.store.currentEditingProps.productId;
            const variantId = this.store.currentEditingProps.variantId;
            const imageToPreview = this.store.currentEditingProps.imageToPreview;

            // Validate index and object existence
            if (index === undefined || index === null || index < 0) {
                console.warn('decreaseTextSize: Invalid index', index);
                return;
            }

            const textDesignObj =
                this.uStore.userDesigns[productId]
                ?.designs[variantId]
                ?.imgVariants[imageToPreview]
                ?.texts[index];

            if (!textDesignObj || !textDesignObj.dragTransform) {
                console.warn('decreaseTextSize: Text object not found at index', index);
                return;
            }

            // Ensure scale object exists
            if (!textDesignObj.dragTransform.scale) {
                textDesignObj.dragTransform.scale = { scaleX: 1.0, scaleY: 1.0 };
            }

            // Debug: Log current state
            if (process.env.NODE_ENV === 'development') {
                console.log('decreaseTextSize called for index:', index, 'Current scale:', textDesignObj.dragTransform.scale?.scaleX);
            }

            const MIN_SCALE = 0.1;
            const currentScale = textDesignObj.dragTransform.scale.scaleX || 1.0;
            
            // Prevent resize if already at min
            if (currentScale <= MIN_SCALE) {
                return;
            }
            
            const nextScale = Math.max(currentScale - 0.1, MIN_SCALE);
            const scaleRatio = nextScale / currentScale;

            // Store current dimensions and position for smooth calculation
            let oldWidth = textDesignObj.dragTransform.width || 0;
            let oldHeight = textDesignObj.dragTransform.height || 0;
            const oldX = textDesignObj.dragTransform.x || 0;
            const oldY = textDesignObj.dragTransform.y || 0;

            // If width/height are 0 or invalid, calculate them from base dimensions
            if (oldWidth <= 0 || oldHeight <= 0 || isNaN(oldWidth) || isNaN(oldHeight)) {
                if (this.store.currentEditingProps.isDesignDst === true) {
                    const baseTextLength = this.store.getTextLength(
                        textDesignObj.text,
                        textDesignObj.fontID,
                        textDesignObj.fontSizeID
                    );
                    const baseTextHeight = this.store.getMaxTextHeight(
                        textDesignObj.text,
                        textDesignObj.fontID,
                        textDesignObj.fontSizeID
                    );
                    const dpiFactor = this.store.currentEditingProps.dpi / 254;
                    oldWidth = baseTextLength * currentScale * dpiFactor;
                    oldHeight = baseTextHeight * currentScale * dpiFactor;
                } else {
                    // For SVG, use a default size if not available
                    oldWidth = oldWidth || 100;
                    oldHeight = oldHeight || 50;
                }
            }

            // Calculate center point (since transform-origin is 0 0)
            // Use precise calculations to avoid rounding errors
            const centerX = oldX + oldWidth * 0.5;
            const centerY = oldY + oldHeight * 0.5;

            // Update scale with precision
            textDesignObj.dragTransform.scale.scaleX = nextScale;
            textDesignObj.dragTransform.scale.scaleY = nextScale;

            // Recalculate width and height based on the new scale
            if (this.store.currentEditingProps.isDesignDst === true) {
                // For DST mode: calculate based on text length and font size
                const baseTextLength = this.store.getTextLength(
                    textDesignObj.text,
                    textDesignObj.fontID,
                    textDesignObj.fontSizeID
                );
                const baseTextHeight = this.store.getMaxTextHeight(
                    textDesignObj.text,
                    textDesignObj.fontID,
                    textDesignObj.fontSizeID
                );
                const dpiFactor = this.store.currentEditingProps.dpi / 254;
                
                const newTextWidth = baseTextLength * nextScale * dpiFactor;
                const newTextHeight = baseTextHeight * nextScale * dpiFactor;

                // Update dimensions with precision
                textDesignObj.dragTransform.width = newTextWidth;
                textDesignObj.dragTransform.height = newTextHeight;

                // Reposition to keep center point fixed (precise calculation)
                textDesignObj.dragTransform.x = centerX - newTextWidth * 0.5;
                textDesignObj.dragTransform.y = centerY - newTextHeight * 0.5;
            } else {
                // For SVG mode: scale width and height proportionally
                const newWidth = oldWidth * scaleRatio;
                const newHeight = oldHeight * scaleRatio;

                textDesignObj.dragTransform.width = newWidth;
                textDesignObj.dragTransform.height = newHeight;

                // Reposition to keep center point fixed (precise calculation)
                textDesignObj.dragTransform.x = centerX - newWidth * 0.5;
                textDesignObj.dragTransform.y = centerY - newHeight * 0.5;
            }

            // Update immediately for smooth resize
            if (process.env.NODE_ENV === 'development') {
                console.log('decreaseTextSize: Updated scale to', nextScale, 'New dimensions:', textDesignObj.dragTransform.width, textDesignObj.dragTransform.height);
            }
            await this.changeStyleByRef("text");
        },

        increaseMonogramSize() {
            console.log("increaseMonogramSize");
        },
        decreaseMonogramSize() {
            console.log("decreaseMonogramSize");
        },
        async changeArc(type, index) {
            // this.boxKey++;
            switch (type) {
                case "art":
                    var artObj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].arts[index];
                    this.store.updateArtLocation(
                        this.store.currentEditingProps.productId,
                        this.store.currentEditingProps.variantId,
                        this.store.currentEditingProps.imageToPreview,
                        index,
                        artObj.artArc
                    );
                    this.store.currentEditingProps.currentPreviewIndex = index;
                    this.store.currentEditingProps.currentPreview = null;
                    await this.changeStyleByRef('art');
                    this.store.currentEditingProps.currentPreview = "art";
                    await this.changeStyleByRef('art');
                    break;
                case "text":
                    var textObj =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                        .designs[this.store.currentEditingProps.variantId].imgVariants[
                            this.store.currentEditingProps.imageToPreview
                        ].texts[index];
                    this.store.updateTextLocation(
                        this.store.currentEditingProps.productId,
                        this.store.currentEditingProps.variantId,
                        this.store.currentEditingProps.imageToPreview,
                        index,
                        textObj.text,
                        textObj.dragLocation.x,
                        textObj.dragLocation.y,
                        textObj.textArc,
                        textObj.fontID,
                        textObj.fontSizeID
                    );
                    this.store.currentEditingProps.currentPreviewIndex = index;
                    // this.store.currentEditingProps.currentPreview = null;
                    // await this.changeStyleByRef('text');
                    // await nextTick();
                    this.store.currentEditingProps.currentPreview = "text";
                    // this.selectElementToPreview(type, index);
                    // await nextTick();
                    // this.k++;
                    await this.changeStyleByRef('text');

                    //continue
                    // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    // this.store.currentEditingProps.variantId
                    // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                    // index].dragTransform.width = this.store.getTextLength(textObj.text, textObj.fontID, textObj.fontSizeID) *
                    // // textObj.dragTransform.scale.scaleX * 
                    // this.store.currentEditingProps.dpi / 254;

                    // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    // this.store.currentEditingProps.variantId
                    // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                    // index].dragTransform.height = this.store.getMaxTextHeight(textObj.text, textObj.fontID, textObj.fontSizeID) *
                    //   // textObj.dragTransform.scale.scaleY * 
                    //   this.store.currentEditingProps.dpi / 254;
                    break;
                default:
                    break;
            }
        },
        async resetArc(type, index) {
            switch (type) {
                case "art":
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].artArc = 0;
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts[index].dragTransform.rotate = 0;
                    await this.changeArc(type, index);
                    break;
                case "text":
                    this.uStore.userDesigns[
                        this.store.currentEditingProps.productId
                    ].designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].texts[index].textArc = 0;
                    await this.changeArc(type, index);
                    break;
                default:
                    break;
            }
        },
        changePreview(num) {
            this.rangeValue += num;
            console.log(this.rangeValue);
        },
        getAllArtsFromDesign() {
            if (this.store.currentEditingProps.isDesignDst == true) {
                return this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts;
            } else {
                var arts =
                    this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId].imgVariants[
                        this.store.currentEditingProps.imageToPreview
                    ].arts;
                var artsResult = [];

                Object.values(arts).forEach(async (art) => {
                    // var svgContent = await this.fetchSvg(this.store.allArtsSVG.value[art.artID].svgFile.relativePath);
                    var svgTag = "";
                    // // if (svgContent) { //return `<div>Failed to load SVG</div>`;
                    // // // Parse and modify SVG
                    // //     const parser = new DOMParser();
                    // //     const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
                    // //     const svgElement = svgDoc.querySelector("svg");
                    // // }
                    // if (svgContent) {
                    // svgContent.setAttribute("fill", this.store.allColors[art.colors[0]].color); // Set the color dynamically
                    // // svgTag = svgElement.outerHTML; // Return the modified SVG as a string
                    // svgTag = svgContent;
                    // }
                    // svgTag = `<div>Invalid SVG content</div>`;
                    svgTag =
                        this.store.baseURL +
                        "/" +
                        this.store.allArtsSVG.value[art.artID].svgFile.relativePath;
                    artsResult.push({
                        artID: art.artID,
                        color: art.colors[0],
                        svgTag: svgTag,
                    });
                });
                return artsResult;
            }
        },
        async insertDesignsToVariantProduct() {
            this.designStatus = 'update-design';
            console.log(
                "insertDesignsToVariantProduct = ",
                document.getElementsByClassName("div-insertDesignsToVariantProduct")
            );
            //var design = document.getElementsByClassName("div-insertDesignsToVariantProduct").dataSet
            // this.store.currentEditingProps.productId = "8048607002920"; //eval("productId"); // "8048607002920";
            // this.store.currentEditingProps.variantId = "44965326749992"; //eval("variantId"); //"44965326815528";
            const { productId, variantId } = this.resolveRuntimeProductVariantIds();
            if (!productId || !variantId) {
                console.error("Missing runtime productId/variantId. Check page globals or component props.");
                return;
            }
            this.store.currentEditingProps.productId = productId;
            this.store.currentEditingProps.variantId = variantId;

            const product = await this.store.GetProductInfoByID(
                this.store.currentEditingProps.productId
            );
            this.store.allProducts = JSON.parse(product);

            if (this.uStore.userDesigns[this.store.currentEditingProps.productId] === undefined) {
                this.uStore.userDesigns[this.store.currentEditingProps.productId] = {
                    designIndex: this.store.currentEditingProps.productId,
                    designID: this.store.createGuid(),
                    productID: this.store.currentEditingProps.productId,
                    designs: {},
                };
                if(document.getElementsByClassName("div-insertDesignsToVariantProduct")[0].dataset.designToAdd == '') {
                    await this.addProductIdToUserDesigns();
                    this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                    .imgVariants[this.store.currentEditingProps.imageToPreview] = {
                        imageName: this.store.currentEditingProps.imageToPreview,
                        texts: [],
                        monograms: [],
                        arts: [],
                        userArts: []
                    };
                } else { 
                    this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId] =
                    JSON.parse(
                        document.getElementsByClassName(
                            "div-insertDesignsToVariantProduct"
                        )[0].dataset.designToAdd
                    );
                }
            } else {
                if(document.getElementsByClassName("div-insertDesignsToVariantProduct")[0].dataset.designToAdd == '') {
                    await this.addProductIdToUserDesigns();
                    this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                    .imgVariants[this.store.currentEditingProps.imageToPreview] = {
                        imageName: this.store.currentEditingProps.imageToPreview,
                        texts: [],
                        monograms: [],
                        arts: [],
                        userArts: []
                    };
                } else { 
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId] =
                    JSON.parse(
                        document.getElementsByClassName(
                            "div-insertDesignsToVariantProduct"
                        )[0].dataset.designToAdd
                    );
                }
            }
                this.imageToPreview = Object.values(
                    this.store.getAllProductVariantUsefulImages(
                        this.store.currentEditingProps.productId,
                        this.store.currentEditingProps.variantId))[0].imageName;

            if(this.imageToPreview != undefined) {

                this.exitScroll();

                await nextTick();
                this.qty = document.querySelector(".quantity__input[data-key-line='" + document.getElementById("input-cart-key").value + "']").value;
                // this.qty = document.querySelector(".quantity__input[data-index='" + document.getElementById("input-cart-key").value + "']").value;

                this.designUserModal = true;
                await nextTick();
                this.$refs.btnOpenModalDesign.$el.click();
                this.finishLoading = false;

                // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
                var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
                // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
                if (modalWidth <= 600) {
                    this.smallMobile = true;
                } else {
                    this.smallMobile = false;
                }

                var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
                if (colorsWidth <= 300) {
                    this.smallColorsLine = true;
                } else {
                    this.smallColorsLine = false;
                }

                await this.calculateDpi();
                this.boxKey++;

                if (this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                    .imgVariants[this.imageToPreview].texts.length == 0) {
                    if (this.store.currentEditingProps.isDesignDst == true) {
                    this.addTextToDesign();
                } else {
                    this.addTextSVGToDesign();
                }
                } else {
                    this.currentPreviewIndex =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                        .imgVariants[this.imageToPreview].texts.length - 1;
                }
                this.currentPreview = "text";
            } else {
                this.designUserModal = true;
                await nextTick();
                this.$refs.btnOpenModalDesign.$el.click();
                this.finishLoading = false;
                var modalWidth2 = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
                if (modalWidth2 <= 600) {
                    this.smallMobile = true;
                } else {
                    this.smallMobile = false;
                }
                var colorsWidth2 = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
                if (colorsWidth2 <= 300) {
                    this.smallColorsLine = true;
                } else {
                    this.smallColorsLine = false;
                }
                this.noUsefulImages = true;
            }
        },

        async insertDesignsToVariantProductChangeDesign() {
            this.designStatus = 'manager-update-design';
            console.log(
                "insertDesignsToVariantProductChangeDesign = ",
                document.getElementsByClassName("div-insertDesignsToVariantProduct")
            );
            this.store.currentEditingProps.productId = this._productId;
            this.store.currentEditingProps.variantId = this._variantId;

            
            const product = await this.store.GetProductInfoByID(
                this.store.currentEditingProps.productId
            );
            this.store.allProducts = JSON.parse(product);

            // var currentProduct =
            //     this.store.allProducts[this.store.currentEditingProps.productId];

            var imageToPreviewObj = Object.values(this.store.getAllProductVariantUsefulImages(
                    this.store.currentEditingProps.productId,
                    this.store.currentEditingProps.variantId))[0];


            this.store.currentEditingProps.isDesignDst = imageToPreviewObj.productType == 'Embroidery' || imageToPreviewObj.productType == undefined ? true : false;
            this.store.currentEditingProps.productType = imageToPreviewObj.productType == undefined ? 'Embroidery' : imageToPreviewObj.productType; //"WoodEngrave", //GlassEngrave //Embroidery //ColorSticker
                    
            if (this.uStore.userDesigns[this.store.currentEditingProps.productId] === undefined) {
                this.uStore.userDesigns[this.store.currentEditingProps.productId] = {
                    designIndex: this.store.currentEditingProps.productId,
                    designID: this.store.createGuid(),
                    productID: this.store.currentEditingProps.productId,
                    designs: {},
                };
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId] =
                    this._designObj;
                // JSON.parse(
                //   document.getElementsByClassName(
                //     "div-insertDesignsToVariantProduct"
                //   )[0].dataset.designToAdd
                // );
            } else {
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId] =
                    this._designObj;
                // JSON.parse(
                //   document.getElementsByClassName(
                //     "div-insertDesignsToVariantProduct"
                //   )[0].dataset.designToAdd
                // );
            }
            this.imageToPreview =
                // this._imgToPreview;
                Object.values(this.store.getAllProductVariantUsefulImages(
                    this.store.currentEditingProps.productId,
                    this.store.currentEditingProps.variantId))[0].imageName;

            if(this.imageToPreview != undefined) {
                this.exitScroll();

                this.openModelToDesign = true;

                await nextTick();
                // this.qty = document.querySelector(".quantity__input[data-index='" + document.getElementById("input-cart-line").value + "']").value;

                this.designUserModal = true;
                await nextTick();
                this.$refs.btnOpenModalDesign.$el.click();
                this.finishLoading = false;

                // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
                var modalWidth = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
                // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
                if (modalWidth <= 600) {
                    this.smallMobile = true;
                } else {
                    this.smallMobile = false;
                }

                var colorsWidth = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
                if (colorsWidth <= 300) {
                    this.smallColorsLine = true;
                } else {
                    this.smallColorsLine = false;
                }

                await this.calculateDpi();
                this.boxKey++;

                if (this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                    .imgVariants[this.imageToPreview].texts.length == 0) {
                    if (this.store.currentEditingProps.isDesignDst == true) {
                    this.addTextToDesign();
                } else {
                    this.addTextSVGToDesign();
                }
                } else {
                    this.currentPreviewIndex =
                        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                        .imgVariants[this.imageToPreview].texts.length - 1;
                }
                this.currentPreview = "text";
            } else {
                this.openModelToDesign = true;

                await nextTick();
                // this.qty = document.querySelector(".quantity__input[data-index='" + document.getElementById("input-cart-line").value + "']").value;

                this.designUserModal = true;
                await nextTick();
                this.$refs.btnOpenModalDesign.$el.click();
                this.finishLoading = false;

                // var modalWidth = this.$refs.embOrderRef != undefined ? this.$refs.embOrderRef.getBoundingClientRect().width : 0;
                var modalWidth2 = this.$refs.modalBodyRef != undefined ? this.$refs.modalBodyRef.$el.getBoundingClientRect().width : 0;
                // var modalWidth = this.$refs.modalContainRef != undefined ? this.$refs.modalContainRef.getBoundingClientRect().width : 0;
                if (modalWidth2 <= 600) {
                    this.smallMobile = true;
                } else {
                    this.smallMobile = false;
                }

                var colorsWidth2 = this.$refs.colorsSelectLineRef != undefined ? this.$refs.colorsSelectLineRef[0].getBoundingClientRect().width : 0;
                if (colorsWidth2 <= 300) {
                    this.smallColorsLine = true;
                } else {
                    this.smallColorsLine = false;
                }
                this.noUsefulImages = true;
            }
        },
        async updateDesign() {
            var imgData = await this.store.getImgDataFromCartDesign(
                this.store.currentEditingProps.productId,
                this.store.currentEditingProps.variantId,
                // this.imageToPreview,
                this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants
            );
            console.log("imgData = ", imgData);
            document.getElementById("div-designImageData").dataset["designImg"] = imgData;
            
            var price = this.store.calculateDesignPriceNew();
            document.getElementById("div-totalPrice").dataset["totalPrice"] = price.totalPrice;
            document.getElementById("div-designsExplains").dataset["designsExplains"] = JSON.stringify(price.designsExplains);

            await eval("updateDesignInCart()");
            document.getElementById("input-cart-key").value = "";
            this.designStatus = 'add-design';
            this.store.deleteVariantFromUserDesign(this.store.currentEditingProps.productId, this.store.currentEditingProps.variantId);
            await eval("reloadPage()");
        },
        async managerUpdateDesign() {
            await this.onManagerUpdateDesign(this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]);
            
            this.openModelToDesign = false;
            // var imgData = await this.store.getImgDataFromCartDesign(
            //     this.store.currentEditingProps.productId,
            //     this.store.currentEditingProps.variantId,
            //     // this.imageToPreview,
            //     this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
            //     .imgVariants
            // );
            // console.log("imgData = ", imgData);
            // document.getElementById("div-designImageData").dataset["designImg"] = imgData;
            
            // var price = this.store.calculateDesignPriceNew();
            // document.getElementById("div-totalPrice").dataset["totalPrice"] = price.totalPrice;
            // document.getElementById("div-designsExplains").dataset["designsExplains"] = JSON.stringify(price.designsExplains);

            // await eval("updateDesignInCart()");


            
            // const saveDesign = () => {
            // כששומרים – פולטים אירוע עם הערכים החדשים
            // await emit('update-design', this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]);
            // this.emit('close');
                // }


            // document.getElementById("input-cart-key").value = "";
            // this.designStatus = 'add-design';
            // this.store.deleteVariantFromUserDesign(this.store.currentEditingProps.productId, this.store.currentEditingProps.variantId);
            // await eval("reloadPage()");
        },
    async addToCart() {
    try {
        this.isAddingToCart = true;
        console.log("click add to cart in vue");
        var imgData = await this.store.getImgDataFromCartDesign(
            this.store.currentEditingProps.productId,
            this.store.currentEditingProps.variantId,
            this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
                .imgVariants
        );
        console.log("imgData = ", imgData);
        document.getElementById("div-designImageData").dataset["designImg"] = imgData;

        var price = this.store.calculateDesignPriceNew();
        document.getElementById("div-totalPrice").dataset["totalPrice"] = price.totalPrice;
        document.getElementById("div-designsExplains").dataset["designsExplains"] = JSON.stringify(price.designsExplains);
        await eval("sendDesignToCart()");
        this.openModelToDesign = false;
        this.store.deleteVariantFromUserDesign(this.store.currentEditingProps.productId, this.store.currentEditingProps.variantId);
        
        await eval("reloadPage()");
    } catch (e) {
        console.error(e);
    } 
    finally {
        this.isAddingToCart = false;
    }
},

        async buyNow() {
            await this.addToCart();
            await eval("goToCart()");
        },

        // async fetchSvg(path) {
        //   if (this.svgCache[path]) {
        //     return this.svgCache[path]; // Return cached content if available
        //   }

        //   try {
        //     const response = await axios.get(path);
        //     this.svgCache[path] = response.data; // Cache the fetched SVG
        //     return response.data;
        //   } catch (error) {
        //     console.error(`Failed to fetch SVG from ${path}:`, error);
        //     return null;
        //   }
        // },

        // toggle

        toggleBoundaries() {
            this.showBoundaries = !this.showBoundaries;
        },
    },
};
</script>

<style >

.qty.product_quantity{
    font-family: Roboto;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
    text-transform: uppercase;
    font-family: 'Zen Kurenaido';
    font-size: 30px;
    color:  #2D2D2D;
    margin-right: 10px;
}
.btn-add {
  margin-right: 10px;
  box-sizing: border-box;
  border: 1px solid #72984F;
  color: #72984F;
  background-color: white;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 12px;          /* ← הוגדל ב־2px */
  line-height: 1;
  text-transform: uppercase;
  padding: 12px 16px 8px 16px;  /* ← padding-top מוגדל טיפה כדי להוריד את הטקסט */
  border-radius: 12px;
  width: 172px;
  height: 39px;
  display: grid;
  place-items: center;
}

.btn-add.add-to-cart-btn {
  cursor: pointer;
  background-color: #72984F;
  color: white;
}

.btn-add.buy-now-btn {
  cursor: pointer;
  background-color: white;
  color: #72984F;
}


.scr-cont{
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
    display: block;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.modal-dialog {
    max-width: 80vw !important;
    /* max-height: 90vh !important; */
}

.vue-dropdown-item {
    display: flex;
    position: relative;
}

.vue-dropdown-item.selected.highlighted {
    background-color: #f3f3f3;
}

.vue-dropdown-item.highlighted {
    background-color: #f3f3f3;
}

.vue-dropdown {
    overflow-x: hidden;
}

.vue-dropdown li {
    display: block;
}

.modal-body {
    padding: 0px;
}

.modal-content {
    --mdb-modal-box-shadow: 0px 0px 4.2px 0px #00000040 !important;
    background: #ffffff !important;
}

.modal-body-container {
    display: grid;
    height: 100%;
    background-color: #fff;
}

.middle-center-top {
    width: 50%;
    margin: auto;
}

.product-box {
    position: relative;
    height: 65vh;
    background: #fff;
    overflow: hidden;
    border-radius: 10px;
}

.emb-canvas {
    overflow: hidden;
    position: relative;
    background-size: contain;
    transition: transform 0.3s ease-out;
    /* background-position: center; */
    /* width: 100%;
  height: 50vh; */
    /* object-fit: cover; */
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
    /* width: 445px;
  height: 441px; */
    position: absolute;
    /* left: 20%;
  top: 10%; */
}

.body-top {
    display: flex;
    gap: 18px;
    height: calc(100vh - 8px - 32px - 28px - 28px - 33.33px);
    /*    padding: 15px;*/
}

.body-top .left {
    padding: 30px;
    height: 100%;
}

.my-app .left-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.left-top .title {
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #252525;
}

.left-top .prev-txt {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    color: #000;
}

.middle-right {
    width: 20%;
    height: 65vh;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}

.zoom-range {
    transform: rotate(270deg);
}

.slider-container {
    touch-action: pan-x;
    height: 173px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 1px solid #d9d9d9;
    width: 37px;
    border-radius: 30px;
}

.slider-container input[type="range"] {
    height: 130px;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
}

.slider-container input[type="range"]::-webkit-slider-runnable-track {
    background: #d8d8d8;
    height: 1px;
}

.slider-container input[type="range"]::-moz-range-track {
    background: #d8d8d8;
    height: 1px;
}

.slider-container input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: #ffffff;
    border: 1.5px solid #72984f;
    height: 14px;
    width: 14px;
    box-shadow: 0px 0px 3.4px 0px #0000001a;
    border-radius: 50%;
    position: relative;
    transform: translateY(-50%);
    /* Centering fix */
}

.slider-container input[type="range"]::-moz-range-thumb {
    -webkit-appearance: none;
    appearance: none;
    background: #ffffff;
    border: 1.5px solid #72984f;
    height: 14px;
    width: 14px;
    box-shadow: 0px 0px 3.4px 0px #0000001a;
    border-radius: 50%;
    transform: translateY(-50%);
    /* Centering fix */
}

.slider-container button {
    font-size: 8px;
}

.bg-image {
    width: 65px;
    height: 65px;
    border-radius: 12px;
    border: 1px solid #d3d3d3;
    box-sizing: border-box;
    margin-bottom: 10px;
}

.bg-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.left-middle {
    display: flex;
}

.middle-center {
    width: 60%;
    margin: auto !important;
}

.middle-center-top {
    overflow: hidden;
    width: 100%;
}

.middle-center-bottom {
    display: flex;
    gap: 10px;
    justify-content: center;
}

button.center-btn {
    border: solid 1px #2d2d2d;
    padding: 6px;
    display: flex;
    gap: 5px;
    align-items: center;
    border-radius: 8px;
    font-size: 14px;
}

.ele-container {
    position: absolute;
}

.middle-left {
    width: 75px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.images-container {
    display: grid;
    gap: 6px;
}

.right {
    /* width: 50%; */
    width: 60%;
    display: grid;
    background-color: rgba(255, 255, 255, 1);
    pointer-events: auto;
}

.modal-header {
    border: none;
}

.part-top-btns {
    margin-bottom: 10px;
}

.part-top-body {
    display: grid;
    gap: 10px;
}

.ele-line {
    display: grid;
}

span.ele-title-txt {
   font-size: 10px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    margin-bottom: unset;
    
    
}

span.ele-input-container {
    display: flex;
}

input.ele-search-input {
    border: 1px solid #D9D9D9;
    border-radius: 4px 0px 0px 4px;
    padding: 3px 6px;
    font-size: 12px;
    max-width: 287px;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #BABABA;
}

.left {
    /* width: 50%; */
    width: 70%;
    padding: 1rem 1rem;
}

span.thumb-value {
    rotate: -90deg;
}

.top-btn-active {
    color: #2D2D2D;
    background-color: #72984F2E;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 21.09px;
    letter-spacing: 0%;
    min-width: 109px;
    padding: 0 12px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    pointer-events: auto;
}


.vue-dropdown{
  width: 100% !important;
  padding: 0 !important;
  border-radius:4px !important;
  max-height:300px !important;
  max-height: 300px !important;
}

.vue-dropdown-item{
    padding: 0px !important;
    /* padding: 5px 20px !important; */
    min-height:30px !important;
    height: 100% !important;
    margin: 0;
}

.top-btn-inactive {
    color: #2D2D2D;
    background-color: transparent;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 21.09px;
    letter-spacing: 0%;
    width: 109px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    pointer-events: auto;
}

.right-top {
    overflow-y: inherit !important;
    ;
}

.right-middle {
    margin: 4px 0px;
}

.right-bottom {
    overflow-y: scroll;
}

/* button.buy-now-btn {
    background-color: #72984F;
    color: white;
    width: 138px;
    border-radius: 8px;
    padding: 4px 10px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
} */

/* button.add-to-cart-btn {
    color: #72984F;
    width: 138px;
    border-radius: 8px;
    padding: 4px 10px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    border: solid 1px #72984F;
}

span.sum-txt {
    font-family: Roboto;
    font-size: 15px;
    font-weight: 600;
}

.body-bottom {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    height: fit-content;
} */

input.ele-input {
    border: 1px solid #d9d9d9;
    border-radius: 4px 0px 0px 4px;
    padding: 3px 12px;
    font-size: 12px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #BABABA;
    height: 32px;
}

.element-div {
    border: 0.4px solid #8A8A8A;
    padding: 9px 11px;
    border-radius: 12px;
    /* display: grid; */
    display: flex;
    flex-direction: column;
    gap: 5px;
    height:100%;
}

.ele-div-active {
    border-width: medium !important;
    height:100%;
}

.element-line-1 {
    display: grid;
}

span.ele-input-container {
    display: flex;
}

.change-size-container {
    border: 1px solid #d9d9d9;
    border-left: none;
}

span.ele-title-txt {


    font-family: "Roboto", sans-serif;
    font-size: 11px;
    line-height: 18.75px;
    text-align: left;
    margin-bottom: unset;
    margin-top: 5px;
    display: block;
}

.btn-add-element {
    cursor: pointer;
    font-size: 14px;
    background: #72984F12;
    padding: 6px 20px;
    border-radius: 20px;
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.41px;
    letter-spacing: 0%;
    display: inline-flex;
    align-items: center;
    float: right;
}

.btn-add-element i {
    margin-right: 4px;
}

.ele-title-line {
    display: flex;
    justify-content: space-between;
}

.remove-container {
    display: flex;
    /* width: 100%; */
    gap: 8px;
    align-items: stretch;
    justify-content: flex-end;
    cursor: pointer;

}

.remove-img {
    height: 16px;
}

.remove-title {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    color: #2D2D2D;
}

span.change-size-container {
    
    display: flex;
    align-items: center;
    gap: 7px;
    /* border: 1px solid #D9D9D9; */
    padding: 0px 16px;
    border-radius: 0px 4px 4px 0px;
}

.body-bottom {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    height: 66px;
    background-color: #ededed;
}

span.sum-txt {
    font-size: 20px;
    font-weight: 600;
    line-height: 23.44px;
    text-align: left;
}

button.add-to-cart-btn {
    color: #72984f;
    width: 138px;
    border-radius: 8px;
    padding: 4px 10px;
    border: solid 1px #72984f;
    width: 172px;
    height: 39px;
    top: 900px;
    left: 1213px;
    gap: 0px;
    border-radius: 12px;
    border: 1px solid #72984f;
    box-sizing: inherit;
    /* opacity: 0px; */
}

button.buy-now-btn {
    margin-right: 10px;
    background-color: #72984f;
    color: white;
    width: 172px;
    height: 39px;
    top: 900px;
    left: 1401px;
    gap: 0px;
    border-radius: 12px;
    /* opacity: 0px; */
}

.toggle-container {
    display: flex;
    align-items: center;
    gap: 10px;
}

.toggle-label {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    color: black;
}

.toggle {
    position: relative;
    width: 40px;
    height: 20px;
}

.toggle input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e5e5e5;
    border-radius: 34px;
    transition: 0.4s;
}

.slider:before {
    content: "";
    position: absolute;
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.4s;
}

input:checked+.slider {
    background-color: #2196f3;
}

input:checked+.slider:before {
    transform: translateX(20px);
}

.toggle-switch {
    display: flex;
    background-color: #ffffff;
    width: 53;
    height: 26;
    border-radius: 30px;
}

.toggle-switch button {
    flex: 1;
    background-color: #ffffff;
    border-radius: 20px;
    font-size: 16px;
    font-weight: bold;
    width: 21px;
    height: 20px;
}

.toggle-switch button.active {
    background-color: #d9d9d9;
}

.preview {
    opacity: 0.5;
    pointer-events: none;
}

.preview-box {
    pointer-events: none;
}

.art-title {
    color: #2d2d2d;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 700;
    line-height: 21.09px;
    margin-left: 2%;
}

/* Range css  */
.vertical-range {
    transform: rotate(-90deg);
    /* Rotate the range input */
    width: 200px;
    /* Adjust width for vertical appearance */
    height: auto;
    /* Allow height to adjust naturally */
    appearance: none;
    /* Optional: Customize appearance */
}

.vertical-range::-webkit-slider-thumb {
    /* Style the thumb */
    width: 15px;
    height: 15px;
    background-color: #007bff;
    border-radius: 50%;
    cursor: pointer;
    appearance: none;
}

.vertical-range::-webkit-slider-runnable-track {
    /* Style the track */
    height: 4px;
    background: #e0e0e0;
    border-radius: 2px;
}

.select-color-container {
    /* width: 100px !important; */
        width: 60px !important;
}
/* .dst-layer{
} */
/* .art-area .dst-layer{
  width: 35px !important;
} */
.my-app .middle-center {
    width: 80% !important;
    margin: auto !important;
}

.my-app .middle-right {
    width: 51px !important;
}

.design-side {
    padding-right: 35px;
}

.right-top {
    height: 40vh;
}

@media only screen and (max-width: 1760px) {
    .emb-canvas {
        left: 10% !important;
    }
}

@media only screen and (max-width: 1500px) {

    /* .overlay-bd{
      top: 236px !important;
    } */
    .my-app .emb-canvas {
        /* width: 322px !important;
      height: 459px; */
        width: 322px !important;
        height: 319px !important;
        position: absolute;
        left: 20%;
        top: 10%;
    }
}

@media only screen and (max-width: 1250px) {
    .design-text {
        width: 90%;
    }

    .design-side {
        width: 90%;
        padding-right: 0 !important;
    }
}

@media only screen and (max-width: 1200px) {
    .design-text {
        width: 100% !important;
    }

    .body-top {
        flex-direction: column;
    }

    .left-top {
        display: none;
    }

    .left {
        height: 254px;
        width: 100%;
        background: #fff !important;
    }

    .my-app .middle-right {
        width: 51px !important;
    }

    .my-app .modal-dialog {
        width: 100% !important;
        max-width: 100% !important;
    }

    .modal-header {
        position: absolute;
        top: 4px;
        right: 4px;
    }

    .middle-center-top {
        width: 80%;
    }

    .right {
        width: 100%;
    }

    .right-top {
        width: 100%;
        height: 100%;
    }

    .part-top-btns {
        width: 90%;
        margin: auto;
        background: #FAFBF9;
        border-radius: 12px;
        padding: 10px;
    }

    .my-app .body-top {
        height: 80vh !important;
        overflow: auto !important;
        padding: 0 !important;
    }

    .top-btn-inactive {
        width: 50%;
        font-family: Roboto;
        font-weight: 400;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        color: #2D2D2D;
    }

    .my-app .top-btn-active {
        width: 50%;
        font-family: Roboto;
        font-weight: 700;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        color: #72984F;
    }

    .my-app .design-side {
        margin: 10px auto;
        overflow-y: inherit !important;
        max-height: 100%;
    }

    .design-text {
        margin: 10px auto;
        max-height: 100%;
    }

    .modal-content {
        overflow-y: auto;
        overflow-x: hidden;
    }

    .right-bottom {
        position: relative;
    }

    .modal-content {
        position: relative;
    }

    .body-bottom {
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        height: auto !important;
        padding: 10px 20px;
    }

    .add-to-cart-btn,
    .buy-now-btn {
        width: 45% !important;
        height: auto;
        font-size: 12px;
    }

    .sum-txt {
        font-size: 12px !important;
        display: block;
        text-align: center;
        width: 100%;
    }

    .toggle-switch-art {
        width: 70% !important;
        row-gap: 0 !important;
        column-gap: 0 !important;
    }

    .toggle-switch-art button.active {
        font-size: 13px !important;
        padding: 7px 16px !important;
    }

    .toggle-switch-art button {
        width: 50% !important;
        font-size: 13px !important;
        padding: 7px 11px !important;
    }

    .search-container {
        width: 30% !important;
        
    }

    /* .gallery-item .dst-layer{
  width: 35px !important;
} */

    .my-app .emb-canvas {
        width: 445px !important;
        height: 441px !important;
        position: absolute;
        top: 119px !important;
        left: -22px;
    }
}

@media only screen and (max-width: 768px) {

    /* .overlay-bd{
      top: 53% !important;
    } */
    .vue-dropdown {
        position: fixed !important;
        top: 0px !important;
        left: 0px !important;
        right: 0px !important;
        margin: auto !important;
        position: fixed !important;
        width: 80% !important;
        max-height: 80vh !important;
        height: 80vh !important;
        bottom: 0 !important;
    }

    .my-app .emb-canvas {
        /* width: 281px !important;

height: 277px !important; */
        width: 281px !important;
        height: 278px !important;
        position: absolute;
        top: 119px !important;
        left: -22px;
    }

    .product-box,
    .middle-right {
        height: 50vh !important;
    }

    .my-app .emb-canvas {
        top: 90px !important;

    }
}

@media only screen and (max-width: 550px) {

    .design-text {
        width: 100% !important;
    }

    .body-top {
        flex-direction: column;
    }

    .left-top {
        display: none;
    }

    .left {
        height: 254px;
        width: 100%;
        background: #fff !important;
    }

    .my-app .middle-right {
        width: 51px !important;
    }

    .my-app .modal-dialog {
        width: 100% !important;
        max-width: 100% !important;
    }

    .modal-header {
        position: absolute;
        top: 4px;
        right: 4px;
    }

    .middle-center-top {
        width: 100%;
    }

    .right {
        width: 100%;
    }

    .right-top {
        width: 100%;
        height: 100%;
    }

    .part-top-btns {
        width: 90%;
        margin: 10px auto !important;
        background: #FAFBF9;
        border-radius: 12px;
        padding: 10px;
    }

    .my-app .art-title {
        font-size: 15px !important;
    }

    .top-btn-inactive {
        width: 50%;
        font-family: Roboto;
        font-weight: 400;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        color: #2D2D2D;
    }

    .my-app .top-btn-active {
        width: 50%;
        font-family: Roboto;
        font-weight: 700;
        font-size: 16px;
        line-height: 18.75px;
        letter-spacing: 0%;
        color: #72984F;
    }

    .my-app .design-side {
        margin: 10px auto;
    }

    .design-text {
        margin: 10px auto;
    }

    .modal-content {
        overflow-y: auto;
        overflow-x: hidden;
    }

    .right-bottom {
        position: relative;
    }

    .modal-content {
        position: relative;
    }

    /* .body-bottom {
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
        height: auto !important;
        padding: 10px 20px;
    } */

    .add-to-cart-btn,
    .buy-now-btn {
        width: 45% !important;
        height: auto;
        font-size: 12px;
    }

    .sum-txt {
        font-size: 12px !important;
        display: block;
        text-align: center;
        width: 100%;
    }

    .toggle-switch-art {
        width: 70% !important;
        row-gap: 0 !important;
        column-gap: 0 !important;
    }

    .my-app .toggle-switch-art button.active {
        font-size: 12px !important;
        padding: 7px 8px !important;
    }

    .toggle-switch-art button {
        width: 50% !important;
        font-size: 13px !important;
        padding: 7px 11px !important;
    }

    .search-container {
        width: 30% !important;
    }

    .gallery-item .dst-layer {
        width: 35px !important;
        
    }

    .design-side {
        margin: 0 auto !important;
    }

    .upload-container p {
        font-size: 11px;
    }

    .upload-txt-explain span {
        font-size: 11px;
    }
}

@media only screen and (max-width: 500px) {
    .my-app .emb-canvas {
        /* width: 190px !important;

height: 281px !important; */
        width: 190px !important;
        height: 188px !important;
        position: absolute;
        left: 12px;
    }

    /* .overlay-bd{
  top: 147px !important
} */
}

@media only screen and (max-width: 420px) {
    .my-app .emb-canvas {
        left: -12px;
    }

    /* .overlay-bd{
  top: 150px !important
} */
    .my-app .colors-box {
        left: -50%;
    }
    /* .btn-add,.add-to-cart-btn {
width: 172px;
height: 39px;
angle: 0 deg;
opacity: 1;
top: 900px;
left: 1401px;
border-radius: 12px;
background: #72984F;
    } */
     


}

</style>
